import React from 'react';
import PolicyListItem from "../PolicyListItem";
import arrowOutline from '../../../assets/arrow_outline.svg';
import arrow from '../../../assets/left-arrow-small.svg';
import dot from '../../../assets/Dot.svg';
import styles from './styles.module.scss';

const PrivacyPolicy = () => {
  const policiesGoogleLink = 'https://policies.google.com/privacy?hl=en&gl=ZZ';
  const amazonPrivacyLink = 'https://aws.amazon.com/privacy';
  const allAboutCookiesLink = 'http://www.allaboutcookies.org/manage-cookies';
  const ChromeLink = 'https://support.google.com/chrome/answer/95647?hl=en';
  const IELink = 'https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d';
  const MozLink = 'https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer';
  const SafariLink = 'https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac';
  const gaoptoutLink = 'https://tools.google.com/dlpage/gaoptout';
  const contactAccuraiser = 'contact@accuraiser.com';

  return (
    <div className={styles.content}>
      {/*First document start*/}
      <div className={styles.firstDoc}>
        <h3 className={styles.headerLarge}>מדיניות פרטיות - אקיורייזר בע"מ</h3>
        <h5 className={styles.headerMedium}>מדיניות פרטיות - אקיורייזר בע"מ</h5>
        <div className={styles.unitHeader}>1. <span
          className={styles.textDecorationUnderline}>הקדמה</span></div>
        <div className={`${styles.spaceBetweenUnits}`}> אנו מודים לך שבחרת
          להשתמש בשירותיה של חברת אקיורייזר בע"מ
          ("<span className={styles.fontWeightBold}>החברה</span>" או "<span
            className={styles.fontWeightBold}>אנחנו</span>"). המשתמשים בשירותינו
          מפקידים בידינו מידע אישי ורגיש
          אודותם,
          ואנו מוקירים על כך ומבינים את גודל האחריות הכרוכה בשמירת מידע מסוג זה.
          על כן,
          פיתחנו את השירותים שלנו בראש ובראשונה מתוך מחשבה על שמירת פרטיותם של
          המשתמשים שלנו,
          ואנו עושים את מירב המאמצים על מנת להגן על המידע שהמשתמשים מעבירים לנו,
          כמפורט להלן.
        </div>
        <div className={styles.spaceBetweenUnits}>
          מדיניות פרטיות זו מתייחסת למידע אישי שאנו אוספים ממשתמשי האתר (להלן: "<span
          className={styles.fontWeightBold}>האתר</span>") והשירותים
          הקשורים, וכן ממבקריו.
        </div>
        <div>
          למונחים המופיעים במדיניות פרטיות זו (להלן: "<span
          className={styles.fontWeightBold}>מדיניות הפרטיות</span>")
          תהיה המשמעות הנודעת להם בתנאי
          השימוש, אלא אם נאמר במפורש אחרת במדיניות פרטיות זו.
        </div>
        <div className={`${styles.spaceBetweenUnits}`}>
          התנאים מנוסחים בלשון זכר לצרכי נוחות בלבד, והם מתייחסים, כמובן, גם
          לנשים.
        </div>
        <div
          className={`${styles.innerPaddingTen} ${styles.borderSolid} ${styles.marginBottom}`}>
          <h5
            className={`${styles.fontWeightBold} ${styles.marginBottom}`}><span
            className={styles.textDecorationUnderline}>שים לב</span>:
          </h5>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                מדיניות פרטיות זו הינה חלק בלתי נפרד מהשירותים ומהמידע הנאסף
                במסגרתם ומתנאי השימוש שלנו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                בעצם הכניסה לאתר והשימוש בו ו/או בשירותים ו/או בעצם רישומך
                ופתיחת חשבון, הנך מביע את הסכמתך לתנאים
                המופיעים במדיניות פרטיות זו, לרבות הסכמתך לאיסוף המידע האישי שלך
                (כהגדרתו להלן), לעיבודו ולשמירתו
                במאגרי המידע שלנו (בארץ ו/או בחו"ל). המידע האישי שלך ישמש לצורך
                מתן השירותים בלבד, כמפורט במסמך
                זה. אם
                אינך מסכים לתנאי מדיניות הפרטיות, אינך מורשה להשתמש בשירותינו.
                מדיניות הפרטיות שלנו עשויה להתעדכן
                בעתיד, ולכן הנך מתבקש להתעדכן מפעם לפעם במדיניות המעודכנת.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אינך מחויב למסור לנו מידע אישי על פי חוק. הנך מסכים ומצהיר בזאת
                שהמידע האישי שהנך מספק לנו נמסר
                מרצונך
                החופשי, על מנת שנוכל לספק עבורך את השירותים ובהתאם למטרות
                המפורטות במדיניות פרטיות זו.
              </div>
            )}
          />
          <div className={styles.spaceBetweenUnits}>
            <span className={styles.textDecorationUnderline}>מי אנחנו</span>:
            אנו אקיורייזר בע"מ, ח.פ. 516238144,
            וכתובתנו הס משה 23, רעננה, ישראל.
          </div>
          <div className={styles.spaceBetweenUnits}>
            <span className={styles.textDecorationUnderline}>שאלות ודיווח על פגיעה בפרטיותך</span>:
            אם יש לך שאלות
            כלשהן, או הערות אחרות בנוגע למדיניות פרטיות זו, או אם אתה סבור
            שפרטיותך נפגעה במהלך השימוש בשירותינו,
            אנא פנה אלינו באמצעות כתובת הדוא"ל: <span
            className={styles.fontStyleItalic}>contact@accuraiser.com</span>.
            נציגי החברה עומדים לרשותך לצורך כל
            בקשה, תגובה, שאלה או תלונה.
          </div>
        </div>
        <div className={styles.unitHeader}>2. <span
          className={styles.textDecorationUnderline}>איזה מידע אנו עשויים לאסוף אודותיך?</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                מידע אישי שנאסף ממך באופן ישיר
              </div>
            )}
          />
          <div>
            במהלך השימוש באתר ו/או בשירותים, מידע אישי מזהה שלך ייאסף ויעובד על
            ידינו (להלן: "<span
            className={styles.fontWeightBold}>מידע אישי</span>"). למשל:
          </div>
          <div className={styles.innerPaddingSix}>
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span
                    className={styles.textDecorationUnderline}>פרטי קשר</span>:
                  אנו אוספים מידע אישי באמצעות
                  טופס
                  "יצירת קשר" באתר, לרבות שם, כתובת דואר אלקטרוני וכל מידע שתבחר
                  להזין בהודעת הפנייה.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span
                    className={styles.textDecorationUnderline}>התקשרויות</span>:
                  אנו נאסוף כל מידע אישי
                  אודותיך
                  אשר תמסור לנו כחלק מההתקשרויות בינך ובינינו (לרבות לצרכי סיוע
                  טכני, מתן משוב לחברה, וכיוצא
                  בזאת),
                  ובין היתר מידע אשר עשוי להימסר על ידך כחלק מההתכתבויות עמנו
                  באמצעות הדואר האלקטרוני, בטלפון או
                  בכל
                  אמצעי תקשורת אחר.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span
                    className={styles.textDecorationUnderline}>פתיחת חשבון</span>:
                  מידע אישי (כדוגמת שמך המלא,
                  מין
                  ומספר רישיון השמאי שלך) ייאסף מתוך הפרטים שנמסרו על ידך במסגרת
                  הירשמותך לאתר.
                </div>
              )}
            />
          </div>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                מידע שנאסף באמצעות טכנולוגיה
              </div>
            )}
          />
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={'כאשר אתה משתמש בשירותים, אנו עשויים לאסוף אודותיך מידע אישי ומידע שאינו אישי (כלומר, מידע אנונימי) באופן אוטומטי.'}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span className={styles.textDecorationUnderline}>מזהים</span>:
                  כאשר אתה משתמש בשירותים, אתה מספק
                  לנו
                  באופן אוטומטי את כתובת ה-IP שלך (או כתובת ה-Mac, לפי המקרה),
                  בהתאם לרשת או למכשיר בו אתה משתמש.
                  מידע
                  זה נאסף על ידינו על מנת לשפר את חוויית המשתמש שלך, כדי לקבוע
                  את מיקומך הגיאוגרפי ולמטרות אבטחה.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span className={styles.textDecorationUnderline}>נתוני מיקום גיאוגרפי</span>:
                  בעת השימוש שלך
                  בשירותים, אנו עשויים לאסוף נתונים אודות מיקומך הגיאוגרפי הכללי
                  (מדינה ועיר), לרבות באמצעות ניתוח
                  של
                  כתובות IP ומידע דומה אחר.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span className={styles.textDecorationUnderline}>מידע טכני והתנהגותי</span>:
                  כמו מרבית האתרים
                  והשירותים המקוונים, אנו אוספים באופן אוטומטי ופסיבי מידע
                  אנונימי ואינו מזהה מהמכשירים שלך כאשר
                  אתה
                  ניגש, משתמש ומדפדף באתר או באפליקציה, לרבות (i) מידע טכני כגון
                  סוג והגרסה של המכשיר שלך ומערכת
                  ההפעלה שלו, סוג הדפדפן, רזולוציית המסך, שפת המקלדת, קישוריות
                  Wi-Fi וכו'; ו- (ii) מידע התנהגותי
                  שיכול
                  לכלול מידע לא אישי, כולל מידע אנונימי, טכני וכן מידע שנאסף
                  אודות התנהגותך, אשר עשוי לכלול, בין
                  היתר,
                  תיעוד של פעילותך בשירותים, זרם הקשות (click-stream) ומידע נוסף
                  בעל אופי דומה (להלן, ביחד: "<span
                  className={styles.fontWeightBold}>מידע
                    טכני והתנהגותי</span>").
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span
                    className={styles.textDecorationUnderline}>דואר אלקטרוני</span>:
                  כאשר אנו שולחים לך דואר
                  אלקטרוני, למשל ניוזלטרים, אנו אוספים באמצעות טכנולוגיות מעקב,
                  מידע אודות עצם מסירת דבר הדואר
                  והאם
                  דבר הדואר נקרא על ידך.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <span className={styles.textDecorationUnderline}>סטטיסטיקות ומדידות</span>:
                  כאשר אנו שולחים לך
                  דואר:
                  אנו עשויים, בעצמנו או באמצעות ספקי שירותים כגון Google
                  Analytics להפיק מדידות, סטטיסטיקות
                  וניתוחים
                  מפורטים על התנהגותך באתר.
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לתשומת לבך, אנו עשויים לאסוף את המידע האמור בפרק זה בעצמנו או
                  באמצעות ספקי השירות שלנו, ובין
                  היתר
                  באמצעות שימוש בטכנולוגיות כגון קבצי עוגיות וטכנולוגיות מעקב
                  דומות (ראה הגדרה ופירוט נוסף להלן).
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  למען הסר ספק, כל מידע שאינו אישי (למשל מידע טכני והתנהגותי)
                  ייחשב למידע אישי, כל עוד הוא קשור או
                  מקושר למידע אישי.
                </div>
              )}
            />
          </div>
        </div>
        <div className={styles.unitHeader}>3. <span
          className={styles.textDecorationUnderline}>כיצד אנו משתמשים במידע אודותיך?</span>
        </div>
        <div className={`${styles.marginBottom} ${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אנו משתמשים במידע <span
                className={styles.textDecorationUnderline}>שאינו אישי</span>:
              </div>
            )}
          />
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצורך מחקר וניתוח סטטיסטי המיועד לשימושנו הפנימי, ובין היתר על
                  מנת שנוכל לקבל החלטות אסטרטגיות
                  מושכלות, תוך הבנה טובה יותר של קהלי היעד שלנו;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצרכי אבטחת מידע ועל מנת לאבטח את שירותינו;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  בכדי להבין כיצד משתמשים בשירותינו ולשם התאמה, פיתוח ושיפור
                  השירותים והמוצרים שלנו; ו-
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי להתאים את השירותים לצרכיך ועל מנת לשפר את חוויית המשתמש
                  שלך כשאתה משתמש בשירותים.
                </div>
              )}
            />
          </div>
          <div className={`${styles.dFlex} ${styles.spaceBetweenUnits} ${styles.marginTopNull}`}>
            <PolicyListItem
              icon={arrowOutline}
              label={(
                <div className={styles.fontWeightBold}>
                  אנו משתמשים <span className={styles.textDecorationUnderline}>במידע אישי</span> כדי:
                </div>
              )}
            />
          </div>
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לספק לך את השירותים;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  להתאים את השירותים באופן אישי לצרכיך;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצרכי אבטחת מידע ועל מנת לאבטח את שירותינו, ובין היתר על מנת
                  שנוכל לאמת את זהותך בעת התחברות
                  לחשבונך;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצורך אימות פרטים, וכן לצורך ביצוע תשלומים שונים עבור השירותים
                  באמצעות ספקי שירותי סליקה;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לשלוח לך הודעות שירות לגבי חשבונך (כגון, באמצעות דואר אלקטרוני
                  או הודעות-פוש), למשל אם לחצת על
                  קישור
                  לאיפוס סיסמה;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי ליצור עמך קשר לצורך מתן תמיכה טכנית בקשר עם השירותים;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי שנוכל לשלוח לך דואר פרסומי, ניוזלטרים ועדכונים על
                  ההתפתחויות בחברה, הצעות חדשות, חדשות בנוגע
                  לשירותים וכיוצא בזאת באמצעות דואר, טלפון, דואר אלקטרוני, SMS,
                  מדיה חברתית, הודעות פוש, או באופן
                  מקוון (במקרים מסוימים ייתכן ונדרש לקבל את הסכמתך הנפרדת
                  והפרטנית לשליחת דיוור מסוג זה);
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי שנוכל לשלוח לך דואר פרסומי, ניוזלטרים ועדכונים על
                  ההתפתחויות בחברה, הצעות חדשות, חדשות בנוגע
                  לשירותים וכיוצא בזאת באמצעות דואר, טלפון, דואר אלקטרוני, SMS,
                  מדיה חברתית, הודעות פוש, או באופן
                  מקוון (במקרים מסוימים ייתכן ונדרש לקבל את הסכמתך הנפרדת
                  והפרטנית לשליחת דיוור מסוג זה);
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצורך מחקר וניתוח סטטיסטי, בין היתר בתחומי הכלכלה ההתנהגותית,
                  המיועדים לשימושינו;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי לקבל מידע ביחס למיקום גיאוגרפי כללי (כלומר, מדינה) של
                  המחשב או המכשיר ממנו אתה מחובר
                  לאינטרנט
                  בעת השימוש בשירותים, וזאת על מנת שנוכל לדעת את מיקומך הכללי
                  לצרכי אבטחת מידע;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  לצרכינו האדמיניסטרטיביים; ו-
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  כדי להגן על זכויותינו ועל מנת למלא כל חובה חוקית החלה עלינו.
                </div>
              )}
            />
          </div>
        </div>
        <div className={styles.unitHeader}>4. <span
          className={styles.textDecorationUnderline}>לכמה זמן אנו שומרים על המידע האישי שלך?</span>
        </div>
        <div className={`${styles.marginBottom} ${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'אנו נשמור את המידע האישי שלך רק כל עוד הוא רלוונטי ומשמש למטרה שלשמה הוא נאסף במקור.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'תיעוד של פניות לשירות הלקוחות שלנו נשמר למשך 12 חודשים מהמועד בו נסתיים הטיפול בפנייה.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'אנו שומרים עותק אחד של כלל המידע שנאסף אודותיך כגיבוי, וזאת למשך 7 שנים. '}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'ייתכן ונצטרך לשמור מידע אישי אודותיך לתקופה ארוכה יותר במקרה של תביעה משפטית או אם אנו נדרשים לכך על פי כל דין.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'מידע אנונימי או אגרגטיבי אשר הופק מהשימוש שלך בשירותים יכול שיישמר בשרתים שלנו ללא מגבלת זמן.'}
          />
        </div>
        <div className={styles.unitHeader}>5. <span
          className={styles.textDecorationUnderline}>שינוי או מחיקה של מידע אישי</span>
        </div>
        <div className={`${styles.marginBottom} ${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                אם מסיבה כלשהי, אתה מעוניין לשנות, לעדכן או למחוק את המידע האישי
                שהעברת לנו, תוכל לשלוח לנו הודעת
                דואר אלקטרוני עם פירוט בקשתך לכתובת: <span
                className={styles.fontStyleItalic}>contact@accuraiser.com</span> ואנו
                נעשה מאמצים סבירים על מנת
                לשנות, לעדכן או למחוק את המידע האישי כאמור, בהתאם לדיני הפרטיות
                החלים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'שים לב: בכל פנייה לבקשה לעיין במידע, נבקש כי יצורפו הפרטים הבאים: שם, טלפון, כתובת, כתובת דואר אלקטרוני והמידע בו הנך מעוניין לעיין או אשר אותו הנך מעוניין לתקן או למחוק. ככל שברצונך לאפשר לאדם אחר לעיין במידע עבורך, נבקש לצרף גם ייפוי כוח מפורש לעניין זה. '}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                <span className={styles.fontWeightBold}>ים לב</span>: אלא אם
                תורה לנו אחרת, אנו רשאים להחזיק במידע
                האישי שלך, כל עוד הדבר נחוץ באופן סביר עבור המטרה שבגינה נאסף
                המידע האישי, לרבות אך לא רק, על מנת
                לעמוד בדרישות, החובות או ההתחייבויות המשפטיות או העסקיות שלנו,
                לפתרון סכסוכים, לאכיפת התנאים, והכל
                בהתאם לדיני הפרטיות החלים.
              </div>
            )}
          />
        </div>
        <div className={styles.unitHeader}>6. <span
          className={styles.textDecorationUnderline}>שיתוף מידע עם אחרים</span>
        </div>
        <div className={`${styles.marginBottom} ${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                ככלל, החברה לא תחלוק את המידע האישי שלך עם צדדים שלישיים, למעט
                לשם מתן השירותים, ככל שהדבר נדרש.
                עם
                זאת, החברה עשויה לעשות כן על מנת:
              </div>
            )}
          />
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={'לאסוף, להחזיק ו/או לנהל את המידע האישי שלך באמצעות ספקים וצדדים שלישיים של מוצרים או שירותים מסוימים (כגון שירותי אירוח ענן) המאושרים על ידינו (לרבות, לפי העניין, לשותפים שלהם), וזאת אך ורק לשם אספקת השירותים המבוקשים על ידינו, ולא לכל מטרה אחרת. צדדים שלישיים מסוג זה עשויים להיות ממוקמים במדינות בהן החוקים להגנה על מידע אישי מספקים הגנה פחותה על מידע אישי מזו שבישראל, אולם אנו נשתמש רק בחברות שיכולות לספק אמצעי הגנה נאותים בכדי להבטיח כי המידע האישי שלך מאוחסן ומטופל בצורה מאובטחת;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'לעמוד בדרישות כל דין, לצרכי הליך משפטי, צווים, לרבות צווי גילוי או בקשת רשות ממשלתית;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'לאכוף מדיניות פרטיות זו או את תנאי השימוש שלנו, לרבות במסגרת חקירה של הפרות אפשריות של מדיניות הפרטיות או תנאי השימוש;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'לגלות, למנוע או לטפל באופן אחר בתרמית, הונאה או בסוגיות אבטחה ובטחון וכן בבעיות טכניות;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'להשיב לתביעות, דרישות או טענות כי מידע ליצירת קשר (לדוגמה, שם, כתובת, כתובת דואר אלקטרוני וכדומה) של צד שלישי פורסם או הועבר ללא הסכמתו או באופן שיש בו משום הטרדה;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'להעביר את תפעול השירותים לחברות הקשורות בקבוצה;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'להגן על הזכויות, הקניין, או על הביטחון האישי של החברה, של לקוחותיה או של הציבור הרחב;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'עבור שיתוף פעולה עם צדדים שלישיים למטרת שיפור חוויית משתמשים ולצורך הענקת השירותים;'}
            />
            <PolicyListItem
              icon={arrow}
              label={'לאפשר מקרה של שינוי שליטה בחברה, לרבות בדרך של מיזוג, רכישה, או רכישה של כלל או עיקר נכסיה, כל עוד הרוכש מתחייב לשמור על אותם תנאי פרטיות שבהצהרה זו; ו/או'}
            />
            <PolicyListItem
              icon={arrow}
              label={'על פי אישור מפורש ממך לפני הגילוי.'}
            />
            <PolicyListItem
              icon={arrow}
              label={'ככל שאושר על ידך, עבור שיתוף עם משתמשים אחרים שבחרו באופציה של מאגר המידע השיתופי (כמפורט בתנאי השימוש).'}
            />
          </div>
          <div>למען הסר ספק, החברה רשאית לאסוף, לגלות ולהעביר מידע אנונימי ולא
            מזהה (להלן, "<span
              className={styles.fontWeightBold}>מידע לא אישי</span>") לצדדים
            שלישיים על פי שיקול דעתה הבלעדי.
          </div>
        </div>
        <div className={styles.unitHeader}>7. <span
          className={styles.textDecorationUnderline}>ספקי שירות חיצוניים</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'החברה נעזרת בשירותים של ספקי שירות חיצוניים. ייתכן ומידע אישי שלך יועבר לרשות ספקי השירות החיצוניים, אך זאת לצורך אספקת השירותים לחברה בלבד ו/או כאמור במדיניות פרטיות זו. כמו כן, ספקי השירות החיצוניים נדרשים לעמוד בהוראות החוק הרלוונטיות החלות ביחס לעיבוד מידע אישי.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'ספקי השירות החיצוניים עלולים להיות ממוקמים באזורי שיפוט שונים מאזור השיפוט שלך, וייתכן שהחוק החל באזור השיפוט של ספקי השירות החיצוניים מספק הגנה פחותה על מידע אישי מזו שבאזור השיפוט שלך, אולם אנו נשתמש רק בספקי שירות שיכולים לספק אמצעי הגנה נאותים בכדי להבטיח כי המידע האישי שלך מאוחסן ומטופל בצורה מאובטחת.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'ספקי השירות החיצוניים של החברה כוללים, בין היתר, את השירותים הבאים:'}
          />
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  שירותי הניתוח, לרבות של Google Analytics, אשר מדיניות הפרטיות
                  שלה מופיעה בלינק הבא: <a
                  target={'_blank'}
                  rel="noreferrer"
                  href={policiesGoogleLink}>https://policies.google.com/privacy?hl=en&gl=ZZ</a>;
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  שירותי ענן, לרבות שירותי ענן של Amazon (AWS), אשר מדיניות
                  הפרטיות שלה מופיעה בלינק הבא: <a
                  target={'_blank'}
                  rel="noreferrer"
                  href={amazonPrivacyLink}>https://aws.amazon.com/privacy</a>;
                </div>
              )}
            />
          </div>
        </div>
        <div className={styles.unitHeader}>8. <span
          className={styles.textDecorationUnderline}>אתרי אינטרנט של צדדים שלישיים</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'קישורים מסוימים באתר יאפשרו לך לעזוב את אתר האינטרנט ולהיכנס לאתרים או שירותים שאינם קשורים לחברה. בין היתר, ייתכן שאתרים אלו של צדדים שלישיים ישלחו קבצי עוגיות (ראה הגדרה להלן) לדפדפן שלך, וכך ישיגו מידע אישי אודותיך.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'החברה אינה נושאת באחריות בגין אתרים מקושרים ו/או ביחס למדיניות הפרטיות של השירותים שלהם. כניסתך, שימושך והסתמכותך על אתרים, שירותים ו/או תכנים של צדדים שלישיים וכן כל התקשרות בינך לבין צדדים שלישיים אלה הנה באחריותך והנך הנושא הבלעדי בהוצאות הקשורות בכך. הגישה לאתרים ושירותים אלה ניתנת אך ורק לנוחיותך. הנך מסכים ומאשר כי החברה לא תהיה אחראית, במישרין או בעקיפין, לכל נזק או הפסד שנגרמו (או שנטען כי נגרמו), בקשר או כתוצאה משימושך בכל שירות, תוכן, מוצר או מידע אחר הזמין באמצעות אתרים או שירותים אלה (לרבות ביחס לשימוש ולגילוי של מידע אישי שלך על ידי צדדים שלישיים אלו).'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'רוב האתרים והשירותים כאמור מספקים מסמכים משפטיים, לרבות תנאי שימוש ומדיניות פרטיות, המסדירים את השימוש בהם (מדובר במדיניות פרטיות שונה ממדיניות פרטיות זו לגבי השימוש והגילוי של מידע אישי שלך על ידך לאתרים של צדדים שלישיים אלו). תמיד רצוי לקרוא מסמכים כאלה בעיון לפני השימוש באתרים אלה ובשירותיהם, בין היתר, על מנת לדעת איזה סוג של מידע הם אוספים.'}
          />

        </div>
        <div className={styles.unitHeader}>9. <span
          className={styles.textDecorationUnderline}>אבטחת מידע</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'אנו משקיעים מאמצים רבים ביישום ובשמירה על אבטחת האתר והמידע האישי של המשתמשים (בין בעצמנו ובין באמצעות קבלת שירותים מצדדים שלישיים שהינם ספקי שירותים מוסמכים). אנו מיישמים נהלים ומדיניות אבטחת מידע כמקובל בתעשייה על מנת להבטיח את אבטחת המידע של המשתמשים ועל מנת למנוע כל שימוש לא מורשה במידע זה.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'עם זאת, עליך לשים לב כי ישנם סיכונים הגלומים בהעברת מידע דרך האינטרנט או שיטות אחרות של אחסון אלקטרוני, ואין אנו יכולים להבטיח כי גישה או שימוש לא מורשים לא יתרחשו באופן מוחלט. החברה לא תישא באחריות או בחבות עבור נזק שייגרם לך בגין גישה בלתי מורשית, פריצה או חדירת מערך האבטחה או בגין כשל באחסון או גניבה, מחיקה, השחתה, הרס, נזק או אובדן נתונים או מידע, למעט ככל שהחברה לא נקטה באמצעי אבטחת המידע הסבירים הנדרשים על פי דין.'}
          />
        </div>
        <div className={styles.unitHeader}>10. <span
          className={styles.textDecorationUnderline}>קטינים</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'קטינים מתחת לגיל שמונה עשרה (18) אינם מורשים להשתמש באתר.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                אנו שומרים על זכותנו לבקש הוכחת גיל בכל שלב, באופן שנוכל לוודא
                שקטינים מתחת לגיל שמונה עשרה (18)
                אינם משתמשים באתר. במקרה שיובא לידיעתנו כי אדם מתחת לגיל שמונה
                עשרה (18) משתמש באתר, אנו נחסום אדם
                זה מלהיכנס לאתר ונעשה כל מאמץ על מנת למחוק מיידית כל מידע אישי
                (כהגדרתו של מונח זה במדיניות
                הפרטיות
                שלנו) בנוגע לאדם כאמור. הנך רשאי לפנות אלינו לכתובת <span
                className={styles.fontStyleItalic}>contact@accuraiser.com</span> אם
                הנך סבור כי אספנו מידע אישי
                ממשתמשים מתחת לגיל שמונה עשרה (18).
              </div>
            )}
          />

        </div>
        <div className={styles.unitHeader}>11. <span
          className={styles.textDecorationUnderline}>עוגיות וטכנולוגיות מעקב</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                בעת השימוש בשירותים, אנו או צדדים שלישיים עשויים להשתמש
                בטכנולוגיה אשר מקובלת בתעשייה ומוכרת
                כ"עוגיות" (cookies), web beacons, pixels, Flash ו/או טכנולוגיות
                מעקב אחרות (להלן: "<span
                className={styles.fontWeightBold}>טכנולוגיות
                    מעקב</span>"). טכנולוגיות מעקב אלה נשמרות על גבי מכשירך
                ומאפשרות לנו להפעיל מאפיינים מסוימים באופן
                אוטומטי (למשל, הפעלה אוטומטית של תהליך ההתחברות), וכן להקל ולפשט
                את חוויית המשתמש שלך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'אתה יכול לנטרל את טכנולוגיות המעקב באמצעות דפדפן האינטרנט שלך. עם זאת, שים לב כי אם תמחק את טכנולוגיות המעקב או לא תאפשר את אחסונן ו/או אם תשנה את מאפייני ה-Flash, החוויה המקוונת שלך בעת השימוש בשירותים שלנו תהיה מוגבלת. '}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'על פי רוב, טכנולוגיות מעקב של צדדים שלישיים שומרות מידע לא אישי, כגון דפי האינטרנט בהם ביקרת, משך החיפוש שלך וכיוצא בזאת. תוכל לרוב למצוא הוראות במדיניות הפרטיות או בתנאי השימוש של צדדים שלישיים בכדי לבצע פעולות בנוגע לאפשרויות המעקב שלהם.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                לקבלת הוראות מפורטות בנוגע לחסימת קבצי עוגיות, אנא עיין בסעיף
                'עזרה' של הדפדפן בו אתה משתמש, או
                בקר
                בכתובת <a target={'_blank'}
                          rel="noreferrer"
                          href={allAboutCookiesLink}>http://www.allaboutcookies.org/manage-cookies</a>.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'בקישורים הבאים תוכל למצוא הנחיות בנוגע לחסימת קבצי עוגיות בדפדפני אינטרנט נפוצים:'}
          />
          <div className={`${styles.innerPaddingSix} ${styles.paddingTopNull}`}>
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <a target={'_blank'} rel="noreferrer" href={ChromeLink}>Chrome</a>
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <a target={'_blank'} rel="noreferrer" href={IELink}>Internet Explorer and
                    Microsoft Edge</a>
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <a target={'_blank'} rel="noreferrer" href={MozLink}>Mozilla Firefox</a>
                </div>
              )}
            />
            <PolicyListItem
              icon={arrow}
              label={(
                <div>
                  <a target={'_blank'} rel="noreferrer" href={SafariLink}>Safari</a>
                </div>
              )}
            />
          </div>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                לידיעתך, אנו משתמשים ב- Google Analytics כספקית שירות המבצעת
                עבורנו ניתוחים של פעילויות המשתמשים
                בפלטפורמה, לרבות באמצעות שימוש בקבצי עוגיות. Google מספקת תוסף
                לדפדפן המאפשר למשתמשים לבטל את
                המעקב
                על ידי Google Analytics בכלל האתרים בהם המשתמש גולש, ואשר ניתן
                להורדה כאן: <a target={'_blank'} rel="noreferrer"
                               href={gaoptoutLink}>https://tools.google.com/dlpage/gaoptout</a>.
              </div>
            )}
          />


        </div>
        <div className={styles.unitHeader}>12. <span
          className={styles.textDecorationUnderline}>דיוור ישיר, דבר פרסומת ושליחת הודעות</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'הנך מסכים לכך שנשתמש בפרטים שלך אשר נמסרו לנו מרצונך, כדי שניידע אותך אודות שירותי החברה, מידע שיווקי ו/או פרסומי (לרבות מסרים פרסומיים לפי חוק התקשורת (בזק ושידורים), התשמ"ב–1982), הטבות ואודות שירותים של צדדים שלישיים שהינם שותפים עסקיים של החברה, אשר יועברו אלייך באמצעות דואר, טלפון, דואר אלקטרוני, SMS, מדיה חברתית, הודעות פוש או בכל אופן מקוון אחר.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                באפשרותך לחזור בך מהסכמתך באמצעות משלוח הודעה לכתובת <span
                className={styles.fontStyleItalic}>contact@accuraiser.com</span> ולחילופין
                למלא אחר ההוראות להסרה
                מרשימת הדיוור, אשר מופיעות בהודעות הנשלחות אליך. הנך מאשר כי
                החברה הודיעה לך כי הינך יכול לסרב
                לקבל
                דברי פרסומת כאמור.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'אתה יכול לבטל את האפשרות לקבל הודעות פוש מאיתנו באמצעות שינוי הגדרות הדפדפן שלך או באמצעות שינוי ההגדרות במערכת ההפעלה של המכשיר ממנו אתה משתמש בשירותינו.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'האתר עשוי לכלול פרסומות של צדדים שלישיים. מובהר, כי החברה אינה אחראית לתוכנן של הפרסומות האמורות ו/או ביחס להתאמתם של המוצרים ו/או השירותים המשווקים באמצעותן והיא אינה ממליצה ו/או מעודדת את המשתמשים לרכוש את המוצרים ו/או השירותים המוצעים במסגרתן. כל המידע המופיע במודעות המסחריות או הפרסומות שייך לאותם צדדים שלישיים והינו באחריותם הבלעדית שלהם, והוא ניתן למשתמשים "כמות שהוא" (AS IS). על החברה אין כל התחייבות או אחריות בהתייחס למידע זה, בין אם לחברה יש שליטה על פרסומים מסחריים אלו, ובין אם לאו. בכל מקרה, החברה לא תהיה אחראית לכל נזק או אובדן שייגרם למשתמש כתוצאה או בקשר למודעות או פרסומות אלו.'}
          />

        </div>
        <div className={styles.unitHeader}>13. <span
          className={styles.textDecorationUnderline}>העברת מידע אישי אל מחוץ לישראל</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'החברה רשאית להעביר מישראל מידע שנאסף אודותיך, לרבות מידע אישי, לגופים קשורים או לספקי שירות צד שלישי (כמפורט במסמך זה) אשר עשויים להיות מצויים במדינות אחרות בעולם. לתשומת ליבך, החברה רשאית להעביר מידע אישי גם למדינה ולסמכות שיפוט שמחילה חוקי הגנת מידע המספקים הגנה פחותה מזו הקבועה בדין בישראל, והינך מסכים להעברת מידע זה.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'ככלל, אנו עושים מאמצים כדי שהמידע האישי שלך יאוחסן רק בישראל, באיחוד האירופי או בארה"ב, אך בכל אופן, בכל העברת מידע אישי מחוץ לישראל, אנו נוקטים באמצעי ההגנה הקבועים בדין הישראלי לעניין העברת מידע מחוץ לגבולות המדינה, וזאת על מנת להבטיח כי המידע שלך נשמר מאובטח בכל עת.'}
          />
        </div>
        <div className={styles.unitHeader}>14. <span
          className={styles.textDecorationUnderline}>שינויים במדיניות הפרטיות</span>
        </div>
        <div className={`${styles.innerPaddingTen}`}>
          <PolicyListItem
            icon={arrowOutline}
            label={'אנו שומרים על הזכות לשנות מדיניות פרטיות זו בכל זמן, ומבקשים כי תשוב ותבקר בדף זה לעיתים קרובות ככל הניתן.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'אנו נודיע לכלל המשתמשים בשירותים על כל שינוי מהותי בתנאי מדיניות פרטיות זו הודעה באתר ו/או נשלח לך (לפי הפרטים שמסרת לנו) הודעת דואר אלקטרוני בנוגע לשינויים כאמור.'}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={'שינויים מהותיים במדיניות הפרטיות ייכנסו לתוקף שבעה (7) ימים ממועד ההודעה כאמור. כל שאר השינויים במדיניות הפרטיות ייכנסו לתוקף בתאריך העדכון האחרון של מדיניות פרטיות זו, והמשך השימוש בשירותינו לאחר תאריך העדכון האחרון יהווה הסכמתך לכך שהשינויים יחייבו אותך. במידה שמדיניות הפרטיות תתוקן בכדי להיענות לכל דרישה חוקית, התיקונים עשויים להיכנס לתוקף באופן מיידי, או כפי שנדרש על פי הדין, וללא כל הודעה מוקדמת.'}
          />
        </div>
      </div>
      {/*First document end*/}
      {/*Second document start*/}
      <div>
        <h3 className={`${styles.headerLarge} ${styles.marginBottom}`}>תנאי
          שימוש - אקיורייזר</h3>
        <div className={styles.unitHeader}>1. <span
          className={styles.textDecorationUnderline}>הקדמה</span>
        </div>
        <div className={`${styles.spaceBetweenUnits}`}>
          אקיורייזר בע"מ (להלן: "<span
          className={styles.fontWeightBold}>החברה</span>" או "<span
          className={styles.fontWeightBold}>אנחנו</span>") מברכת אותך (להלן:
          "<span
          className={styles.fontWeightBold}>המשתמש</span>" או "<span
          className={styles.fontWeightBold}>המשתמשים</span>") על שימושך באתר
          האינטרנט שלנו בכתובת platform.accuraiser.com (לרבות דומיינים משניים
          ודומיינים נלווים, אליהם משויכים תנאי
          שימוש אלו), (להלן: "<span
          className={styles.fontWeightBold}>האתר</span>"). האתר מספק פלטפורמה
          דיגיטלית
          המסייעת בתהליך הערכת שווי נדל"ן למגורים - בניה
          רוויה ודשבורד ניהולי הכולל אדמין (להלן: "<span
          className={styles.fontWeightBold}>השירותים</span>",
          כמפורט
          בתנאים אלו). תנאי שימוש אלה חלים על מבקרי
          ומשתמשי האתר והשירותים.
        </div>
        <div className={styles.marginBottom}>
          תנאי השימוש מנוסחים בלשון זכר לצרכי נוחות בלבד, והם מתייחסים, כמובן,
          גם לנשים.
        </div>
        <div
          className={`${styles.innerPaddingTen} ${styles.borderSolid} ${styles.marginBottom}`}>
          <h5 className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
            <span className={styles.textDecorationUnderline}>שים לב</span>:
          </h5>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אנא קרא בעיון את תנאי השימוש לפני שאתה משתמש בשירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                התנאים מהווים הסכם משפטי מחייב וניתן לאכיפה בין החברה לבינך.
                בעצם הכניסה לאתר והשימוש בו ו/או בעצם
                רישומך ופתיחת חשבון (כהגדרתו להלן), הנך מאשר כי קראת והבנת את
                תנאי השימוש הבאים (וכי התנאים יחייבו
                אותך וכי תפעל בהתאם להם), לרבות התנאים המפורטים במדיניות הפרטיות
                של החברה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אם אינך מסכים לאי אלו מתנאי השימוש המפורטים להלן, הנך מחויב,
                באופן מידי, להימנע מכניסה, מהתחברות
                או
                משימוש בכל אופן בשירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                האתר ותוכן המשתמשים והתכנים ניתנים לך "כמות שהם" (“AS-IS”). אתה
                מסכים ומאשר כי השימוש באתר,
                בשירותים
                ובתוכנים (לרבות תוכן צדדים שלישיים) הינו באחריותך הבלעדית.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אתה מסכים ומאשר כי לחברה, לרבות עובדיה, ספקיה, מנהליה, קבלני
                המשנה שלה, גורמים וצדדים שלישיים
                קשורים, נותני הרישיון שלה ושלוחיה, אין כל אחריות לדוחות השמאי
                המוצעים ו/או לכל תוצאות העשויות
                לנבוע
                משימוש בשירותים, בתוכן צדדים שלישיים ובתכנים, לרבות אחריות בנוגע
                לתפקוד השירותים, למהירות ואמינות
                השירותים ו/או לתוצאות השימוש בהם ו/או להתקשרות בין המשתמש לבין
                לקוחותיו. החברה ו/או נציגי החברה
                המורשים כאמור לעיל, לא יהיו אחראיים לנזק כלשהו, לרבות אך לא רק,
                כל נזק הנובע משימושך בדוחות השמאי
                המוצעים ו/או בשירותים, בתוכן המשתמשים ובתכנים או על הסתמכותך
                עליהם. לחברה לא תהא כל אחריות ביחס
                לטעויות או לאי דיוקים שנפלו בכל מידע המופיע באתר. המשתמש יהיה
                אחראי לכל החלטה שיקבל בקשר עם שימוש
                באתר ו/או בחוות דעת שמאי המוצעות. מובהר כי ההחלטה הסופית של
                המשתמש בהפקת חוות דעת שמאי ללקוחותיו
                באמצעות האתר הינה באחריותו הבלעדית וכי החברה לא תישא בשום אחריות
                בגין חוות דעת מקרקעין שמבצע
                המשתמש.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                החברה מעודדת את המשתמשים לוודא כי הנתונים שמוזנים על ידם ו/או
                מופקים ע"י צדדים שלישיים במסגרת
                השירותים מדויקים. החברה לא לוקחת כל אחריות בקשר עם המידע שמוזן
                ע"י המשתמשים ו/או אשר מועלה ע"י
                המשתמשים על פי שיקול דעתם הבלעדי. החברה לא תשא באחריות לגבי מידע
                ו/או נתונים של צדדים שלישיים,
                לרבות
                בקשר לדיוקו או שלמותו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                אתה אחראי לכל החלטה שתקבל בקשר עם שימוש באתר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                היה והמשתמש ו/או המעסיק (לפי העניין) בחרו באפשרות של שימוש במאגר
                המידע השיתופי, המשתמש ו/או המעסיק
                יהיו האחראיים הבלעדיים לאיכות, שלמות ודיוק המידע השיתופי וכן לכל
                שימוש שלהם במידע שיתופי של
                משתמשים
                אחרים באתר. החברה ו/או נציגי המורשים לא יהיה אחראיים לנזק כלשהו
                הנובע לבחירת משתמש ו/או מעסיק
                באופצית מאגר המידע השיתופי ו/או בשימוש כלשהו במידע שיתופי על ידו
                ו/או על ידי משתמשים אחרים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div className={styles.fontWeightBold}>
                במידה ויש לך שאלות נוספות או הערות בנוגע לתנאים אלו, הנך מוזמן
                לפנות אלינו באמצעות הודעת דואר
                אלקטרוני לכתובת <a target={'_blank'} rel="noreferrer"
                                   href={contactAccuraiser}>contact@accuraiser.com</a>.
                נציגי
                החברה עומדים לרשותך לצורך כל בקשה, תגובה, שאלה או
                תלונה.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>2. <span
          className={styles.textDecorationUnderline}>	שירותי החברה, תנאים למוכרים, תנאים לרוכשים</span>
        </div>
        <div className={`${styles.marginBottom} ${styles.fontWeightBold}`}>
          האתר מהווה פלטפורמה המאפשרת למשתמשיו לערוך ולהפיק חוות דעת שמאי
          למקרקעין נדל"ן למגורים - בניה רוויה.
        </div>
        <div className={`${styles.marginBottom} ${styles.fontWeightBold}`}>
          האתר מאפשר למשתמשיו גישה לשירותים הבאים:
        </div>
        <div className={styles.paddingYTen}>
          <PolicyListItem
            icon={dot}
            label={(
              <div>
                <span className={styles.fontWeightBold}>דוח חדש </span>
                - תהליך העבודה הדיגיטלי המלווה את השמאי בעריכת דוח מלא.
              </div>
            )}
          />
          <PolicyListItem
            icon={dot}
            label={(
              <div>
                <span className={styles.fontWeightBold}>מאגר הדוחות שלי </span>
                - דוחות שמאיים של המשתמש שבוצעו באמצעות הפלטפורמה ונתוני דוחות אחרים שהוזנו
                על ידי המשתמש באדמין.
              </div>
            )}
          />
          <PolicyListItem
            icon={dot}
            label={(
              <div>
                <span className={styles.fontWeightBold}>מאגר דוחות המשרד </span>
                - דוחות שמאיים של כל משתמשי המשרד.
              </div>
            )}
          />
          <PolicyListItem
            icon={dot}
            label={(
              <div>
                <span className={styles.fontWeightBold}>מאגר מידע שיתופי </span>
                - נתונים וקבצים של כל משרדי השמאים המשתמשים בפלטפורמה אשר אישרו שיתוף דאטה
                תמורת דאטה.
              </div>
            )}
          />
          <PolicyListItem
            icon={dot}
            label={(
              <div>
                <span className={styles.fontWeightBold}>דשבורד ניהולי </span>
                <span>- הכניסה לדשבורד הניהולי מיועדת למעסיקים ו/או למשתמשים עצמאיים, שהוסמכו ככאלו
                  בהסכם ההתקשרות מול החברה (להלן: <span className={styles.fontWeightBold}>"אדמין"</span>). הדשבורד
                  הניהולי מאפשר:</span>
                <div className={styles.paddingXTwenty}>
                  <div className={styles.dFlex}>
                    <div className={styles.itemNumberMark}>1.</div>
                    <span>בקרה מלאה על דוחות שמאי המשרד.</span>
                  </div>
                  <div className={styles.dFlex}>
                    <div className={styles.itemNumberMark}>2.</div>
                    <span>תמונת מצב ברורה ואיכותית לגבי פעילות המשרד.</span>
                  </div>
                  <div className={styles.dFlex}>
                    <div className={styles.itemNumberMark}>3.</div>
                    <span>ניהול לקוח מלא כולל בילינג ("חשבונית ירוקה").</span>
                  </div>
                  <div className={styles.dFlex}>
                    <div className={styles.itemNumberMark}>4.</div>
                    <span>הצגת מידע סטטיסטי הנשאב ממאגר הדאטה הנצבר בענן כתוצאה משימוש בפלטפורמה</span>
                  </div>
                </div>

              </div>
            )}
          />
        </div>
        <div className={styles.marginBottom}>(להלן, ביחד: "<span
          className={styles.fontWeightBold}>השירותים</span>").
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              תנאים למשתמשים:
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                <span
                  className={styles.textDecorationUnderline}>הצהרות השמאי</span>:
                השמאי מצהיר ומתחייב כי (א)
                הינו שמאי מקרקעין מורשה על פי כל דין (לרבות חוק שמאי מקרקעין,
                התשס"א-2001) או מתמחה לשמאות
                מקרקעין;
                ו-(ב) קיבל את כל ההסכמות והאישורים הנדרשים על פי דין, לרבות חוק
                הגנת הפרטיות התשמ"א-1981, ותקנותיו
                (להלן:"<span className={styles.fontWeightBold}>חוק
                    הגנת הפרטיות</span>"), בקשר עם מידע אישי כלשהו שיעביר ו/או
                יזין באתר בקשר עם השירותים (לרבות מידע
                אישי של לקוחותיו), כל מידע אישי כאמור נאסף ויועבר על ידיו בהתאם
                להוראות כל דין (לרבות חוק הגנת
                הפרטיות), וככל שנדרש, רשם ומנהל מאגר מידע, ורשם את החברה כמחזיק
                במאגר, כנדרש על פי חוק הגנת
                הפרטיות.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                <span
                  className={styles.textDecorationUnderline}>שמירת מידע</span>:
                מידע המועלה ע"י משתמשי
                הפלטפורמה
                יישמר ע"י החברה בהתאם למדיניות הפרטיות וכנדרש לפי כל דין.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                      <span
                        className={styles.textDecorationUnderline}>הגבלת חתימה על חוות דעת שמאי (ככל שרלוונטי)</span>:
                המעסיק של המשתמש יכול להגביל את הרשאת המשתמש לחתום על חוות הדעת
                המוצעות המופקות ע"י האתר. היה
                והמעסיק ביקש להגביל אפשרות זו, המשתמש לא יוכל לחתום על שומות
                המוצעות ע"י האתר, ואלו ייחתמו ע"י
                המורשים הרלוונטיים אצל המעסיק.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              תנאים למעסיק (ככל שרלוונטי):
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                <span
                  className={styles.textDecorationUnderline}>צהרות המעסיק</span>:
                המעסיק מצהיר ומתחייב כי (א)
                קיבל את כלל האישורים הנדרשים על פי כל דין, לרבות חוק הגנת
                הפרטיות, בקשר עם העברת פרטי ההתקשרות של
                השמאים במשרדו לחברה, לצורך פתיחת חשבונות משתמש עבורם; ו-(ב) קיבל
                את כל האישורים הנדרשים על פי דין,
                לרבות חוק הגנת הפרטיות בקשר עם מידע אישי כלשהו שיועבר ו/או יוזן
                ע"י המשתמשים מטעמו באתר בקשר עם
                השירותים (לרבות מידע אישי של לקוחותיו), וכי כל מידע אישי כאמור
                נאסף ויועבר על ידי המשתמשים מטעמו
                בהתאם להוראות כל דין (לרבות חוק הגנת הפרטיות), וככל שנדרש, רשם
                ומנהל מאגר מידע, ורשם את החברה
                כמחזיק
                במאגר, כנדרש על פי חוק הגנת הפרטיות.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              האדמין:
            </div>
          )}
        />
        <div className={`${styles.innerPaddingTen} ${styles.paddingTopNull}`}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                זהות האדמין תיקבע ע"י המעסיק (ו/או המשתמש העצמאי, לפי העניין),
                במסגרת ההתקשרות מול החברה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האדמין יאשר, באמצעות הפלטפורמה, את כלל חוות דעת השמאי שיבוצעו
                ע"י המשתמשים מטעמו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האדמין יוכל, באמצעות מסך רשימת חוות דעת שמאי, לצפות ולסנן את כל חוות דעת השמאי שמבוצעות
                מטעמו. האדמין יכול לבחון את חוות דעת השמאי הממתינות לאישורו, לרשום הערות ותיקונים ולשלוח אותן
                למייל של המשתמש שביצע את חוות דעת השמאי.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האדמין יוכל להקים ולנהל לקוח ובנוסף להפיק הצעת מחיר, הזמנת עבודה, חשבון עסקה, חשבונית מס
                וקבלה באמצעות "חשבונית ירוקה".
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              התכנים באתר
            </div>
          )}
        />
        <div className={`${styles.innerPaddingTen} ${styles.paddingTopNull}`}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האתר עשוי להכיל תכנים, מסמכים, מלל, קבצים, לוגואים, אייקונים,
                תמונות, סרטונים, קישורים, מאגרי
                נתונים, נתונים טכניים, ידע, מפרטים, “look and feel”, אלגוריתמים,
                ממשקים, GUI, תכונות
                אינטראקטיביות,
                גרפיקה ומאפיינים אחרים, לרבות תכנים כאמור שנמסרו לנו מצדדים
                שלישיים ותוכן צדדים שלישיים כהגדרתו של
                מונח זה להלן (להלן: "<span
                className={styles.fontWeightBold}>התכנים</span>").
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האתר עשוי לכלול תכנים של צדדים שלישיים, לרבות תמונות ומידע לגבי
                הלקוחות של המשתמש ו/או לקוחות
                אחרים
                של המעסיק (ככל שרלוונטי) (להלן: "<span
                className={styles.fontWeightBold}>תוכן
                    צדדים שלישיים</span>").
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל הזכויות בתכנים הינן בבעלות החברה ו/או ניתנו לה ברישיון כדין.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              תשלומים
            </div>
          )}
        />
        <div className={`${styles.innerPaddingTen} ${styles.paddingTopNull}`}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                תשלומים בעבור השירות יבוצעו בהתאם להסכמים בינך ו/או בין המעסיק
                לבין החברה.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              הודעות והתראות
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              האתר עשוי לכלול אימיילים ומסרונים. הנך מסכים בזאת לקבלת כל אלה.
              הנך רשאי לבטל את הסכמתך לקבלת הודעות
              כאמור, בכל עת, באמצעות מעקב אחר ההוראות הכלולות בהודעה שנשלחה אליך
              או באמצעות שינוי ההגדרות במכשיר
              ממנו אתה גולש באתר, לפי נסיבות העניין.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              אחריות המשתמש והסרת אחריות של החברה ונציגיה
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אנו פועלים ללא לאות על מנת להעניק לך את השירות הטוב ביותר. עם
                זאת, וכמו בכל שירות מקוון אחר, ישנם
                סיכונים מסוימים בעת השימוש בשירותים, ועל כן שימושך בהם,
                והסתמכותך על התכנים המוצגים לך כחלק משימוש
                זה, הינם על אחריותך בלבד, ואנו ממליצים כי השימוש בשירותים ייעשה
                תוך הפעלת שיקול דעת, בכל עת.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>3. <span
          className={styles.textDecorationUnderline}>פתיחת חשבון</span></div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          פתיחת חשבון משתמש באתר נעשית ע"י החברה, באמצעות הפרטים שקיבלה מהמשתמש
          ו/או מהמעסיק (להלן: "החשבון").
          תוכל
          למחוק את החשבון שנוצר לך באמצעות שליחת דוא"ל לכתובת <a
          target={'_blank'} rel="noreferrer"
          href={contactAccuraiser}>contact@accuraiser.com</a>.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              אופן פתיחת חשבון
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                המידע שתספק לנו במסגרת פתיחת החשבון נדרש להיות מלא, מדויק ונכון,
                והנך מסכים בזאת כי לא תציג שלא
                כהלכה את זהותך או כל פרט אחר בחשבונך. היה וסברנו כי הקמת חשבון
                באמצעות פרטי זיהוי של אדם אחר, הרי
                שבכך אתה חושף את עצמך לאחריות פלילית ו/או אזרחית.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                רק יחידים העומדים בתנאי רישום לשירות המפורטים בהרחבה בסעיף 4
                להלן, יהיו רשאים לפתוח חשבון.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אתה אחראי באופן בלעדי ומלא, לשמור על סודיות הסיסמה, שם המשתמש
                והחשבון שלך ועל כל פעילות אשר תתבצע
                תחת הסיסמה שלך או במסגרת החשבון שלך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אם ברצונך לשנות סיסמה או לשחזר סיסמה תוכל לעשות זאת באמצעות
                שינוי הגדרות החשבון שלך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אינך רשאי להעביר או להמחות את זכויותיך או להאציל את חובותיך
                בחשבון, ללא הסכמתנו המוקדמת בכתב.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              אבטחת מידע
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                באחריותך לנקוט בכל האמצעים הנדרשים לשם שמירה על סודיותם של פרטי
                המשתמש שלך, ולוודא שאף גורם שאינו
                מורשה לצפייה במידע ו/או שאינו מורשה להשתמש באתר לא ישתמש בו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה לא תישא באחריות או בחבות עבור נזק שייגרם לך בגין גישה בלתי
                מורשית, פריצה או חדירת מערך
                האבטחה
                או בגין כשל באחסון או גניבה, מחיקה, השחתה, הרס, נזק או אובדן
                נתונים או מידע (לרבות ביחס לאובדן או
                נזק שנגרמו כתוצאה משימוש בלתי מורשה במכשיר הנייד שלך), למעט ככל
                שהחברה לא נקטה באמצעי אבטחת המידע
                הסבירים הנדרשים על פי דין.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                עליך לדווח לנו באופן מידי על כל שימוש בלתי מורשה בחשבונך, ובכלל
                זה בקשר לכל פריצת אבטחה למכשיר
                ממנו
                אתה משתמש בשירותים.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              מחיקת החשבון
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                על מנת למחוק את החשבון שלך, תוכל לפנות אלינו באמצעות כתובת
                המייל <a target={'_blank'} rel="noreferrer"
                         href={contactAccuraiser}>contact@accuraiser.com</a>.
                ביטול
                החשבון יבוצע תוך זמן סביר לאחר פנייתך, ומרגע הביטול לא תוכל עוד
                להשתמש בשירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                שים לב: מחיקת החשבון עשויה לגרום לאבדן תכנים ונתונים (לרבות תוכן
                שצברת) והחברה לא תישא בכל אחריות
                בנוגע לאבדן זה.
              </div>
            )}
          />


        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>4. <span
          className={styles.textDecorationUnderline}>תנאים מקדמיים לשימוש באתר</span>
        </div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          על מנת להשתמש באתר, עליך לעמוד במספר תנאים, המפורטים להלן. קטינים מתחת
          לגיל שמונה עשרה (18) אינם מורשים
          להשתמש באתר. אנו שומרים על זכותנו לבקש הוכחת גיל בכל שלב, באופן שנוכל
          לוודא שקטינים מתחת לגיל שמונה עשרה
          (18) אינם משתמשים באתר. במקרה שיובא לידיעתנו כי אדם מתחת לגיל שמונה
          עשרה (18) משתמש באתר, אנו נחסום אדם
          זה
          מלהיכנס לאתר ונעשה כל מאמץ על מנת למחוק מיידית כל מידע אישי (כהגדרתו
          של מונח זה במדיניות הפרטיות שלנו)
          בנוגע לאדם כאמור. הנך רשאי לפנות אלינו לכתובת <span
          className={`${styles.fontStyleItalic} ${styles.fontWeightNormal}`}>contact@accuraiser.com</span
        > אם הנך סבור כי אספנו מידע אישי ממשתמשים
          מתחת לגיל שמונה עשרה (18).
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              תנאים לשימוש באתר
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <div className={`${styles.marginBottom}`}>
            על מנת להירשם ולהשתמש באתר, עליך לעמוד בכל התנאים הבאים:
          </div>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                עליך להיות כשיר לבצע פעולות משפטיות.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                עליך להיות בעל תיבת דואר אלקטרוני תקפה ופעילה ברשת האינטרנט.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                עליך להיות שמאי מקרקעין מורשה על פי כל דין (לרבות חוק שמאי
                מקרקעין, התשס"א-2001) או מתמחה לשמאות
                מקרקעין.
              </div>
            )}
          />
          <div>
            החברה תהיה רשאית למנוע ממך מלפתוח חשבון או לקבל את השירותים בכל מקרה
            שבו יתעורר חשש סביר, לפי שיקול
            דעתה
            הבלעדי, כי ביצעת מעשה בלתי חוקי ו/או עברת על הוראות הדין ו/או הפרת
            תנאי מתנאי שימוש אלו ו/או מסרת בעת
            ההרשמה ו/או לאחר מכן פרטים שגויים ו/או ביצעת מעשה או מחדל שיש בו כדי
            לפגוע בחברה ו/או במי מטעמה ו/או
            בפעילות התקינה של השירות ו/או בצד ג' כלשהו. אין בחסימה, בהפסקה או
            בהגבלת השימוש, כאמור לעיל, כדי להטיל
            על החברה אחריות כלשהי ו/או כדי לגרוע מחובתך לנהוג בכל עת בהתאם לתנאי
            שימוש אלו.
          </div>

        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>5. <span
          className={styles.textDecorationUnderline}>תוכן צדדים שלישיים</span>
        </div>
        <div
          className={`${styles.fontWeightBold} ${styles.textDecorationUnderline} ${styles.marginBottom}`}>
          תוכן צדדים שלישיים
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              האתר מאפשר למשתמשים להעלות, לפרסם, לחלוק יצירות העשויות להיות
              מוגנות בזכויות יוצרים כגון תמונות
              פרופיל, תמונות של נכסים, פרטי נכסי מקרקעין וטקסטים קשורים ("<span
              className={styles.fontWeightBold}>תוכן
                    צדדים שלישיים</span>"). אנא ודא כי שימושך באתר מכבד את
              הזכויות הקנייניות (לרבות זכויות קניין רוחני
              והזכות לפרטיות) של בעלי תוכן צדדים שלישיים אותו העלית לאתר. החברה
              לא תישא באחריות לכל נזק, הפסד,
              עלות או הוצאה העלולים להיגרם לך כתוצאה מהעלאת תוכן צדדים שלישיים
              או בקשר להעלאה כאמור. הנך מסכים
              ומאשר כי הנך נושא באחריות בלעדית לתוכן צדדים שלישיים שאתה מעלה
              באמצעות השימוש בשירותים ולהשלכות
              השימוש בתוכן זה על ידי החברה ועל ידי צדדים שלישיים.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              בעת שאתה מעלה תוכן צדדים שלישיים אשר יוצג למשתמשים אחרים (לרבות
              משתמשים אחרים אצל המעסיק ו/או אצל
              משתמשים אחרים ככל שמומשה האופציה לשימוש במאגר מידע שיתופי) באמצעות
              שימוש בשירותים עליך להקפיד שתוכן
              צדדים שלישיים זה יהיה חוקי. בין השאר ועל דרך ההדגמה בלבד, אין
              להציג באמצעות שימוש בשירותים את תוכן
              המשתמשים הבא:
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן הפוגע בזכויות קנייניות של אחרים או מפר אותן – לרבות
                העתקת ו/או הפצת תמונות שאינן ברשותך;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן היוצר סיכון לבטיחותו, ביטחונו או בריאותו של אדם;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן המזהה אישית אנשים אחרים, מבלי שנתנו את הסכמתם לפרסום
                זהותם, או כל תוכן הנוגע לקטינים ומזהה
                אותם, את פרטיהם האישיים או את מענם ודרכי ההתקשרות עימם (ובלבד
                שמידע זה נמסר או פרסומו אושר על ידי
                הגורם המוסמך על פי דין להעלאות תוכן שכזה);
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן בלתי חוקי, לרבות תוכן המהווה לשון הרע, או הפוגע בפרטיותו
                של אדם או בשמו הטוב;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן המציג קטינים באופן מיני;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן בעל אופי פורנוגרפי או בעל אופן מיני בוטה, או תוכן
                טורדני, מעליב, עוין, מאיים, גס רוח או
                פוגע
                ברגשות הציבור;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן שיש בו או שהוא מעודד לגזענות, או אפליה פסולה על בסיס
                גזע, מוצא, צבע עור, עדה, לאומיות, דת,
                מין, עיסוק, נטייה מינית, מחלה, נכות גופנית או נפשית, אמונה,
                השקפה פוליטית, או מעמד חברתי-כלכלי;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן המעודד ביצוע עבירה פלילית או עלול להוות בסיס לתביעה או
                אחריות אזרחית;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל מידע שהגישה אליו חסומה באמצעות סיסמה וכיו"ב, ואינה מתאפשרת
                באופן חופשי לכל משתמשי האינטרנט;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן האסור לפי דין, לרבות על פי צווי איסור פרסום של בית משפט,
                או לפי תנאי שימוש אלה;
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תוכן המביע או מרמז באופן שקרי כי תוכן כאמור הינו בחסות או
                מקודם על ידי החברה, או שיש בו זדון או
                תרמית מכל בחינה אחרת.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              האתר מאפשר גישה לאתרים של צדדים שלישיים לצורך שליפת מידע לבקשת המשתמש, לצורך עריכת חוות
              דעת שמאי. אתרים אלו כוללים אתרים ממשלתיים (למשל: אתר משרד המשפטים ואתר רשות המיסים) וכן
              אתרים פרטיים (למשל: טאבו ישיר).
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              לחברה אין כל חובה לבחון, לשנות או לנטר תוכן צדדים שלישיים. יחד עם
              זאת, החברה רשאית (אך לא חייבת)
              לבדוק
              תוכן צדדים שלישיים לפני ואחרי פרסומם ו/או שימוש שלהם באמצעות
              השירותים, לסרב להציג באמצעות השירותים
              תוכן צדדים שלישיים, לשנות או למחוק לאלתר בכל עת כל תוכן צדדים
              שלישיים שהעברת לחברה אם הפרת את התנאים
              או שעשית מעשה או מחדל הפוגע או עלול לפגוע בשירותים, במשתמשים,
              בחברה או במי מטעמה, או מכל סיבה אחרת
              הנתונה לשיקול דעתה המלא של החברה. הוראות סעיף זה מוסיפות על זכויות
              החברה לפי כל דין ואינן מחייבות
              אותה
              לנטר את תוכן המשתמשים אשר זמין בשירותים.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              החברה עשויה ליצור הגבלות לשימוש בשירותים, לרבות הגבלות בדבר גודל
              ונפח אחסון הזמינים לתוכן צדדים
              שלישיים.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              הנך אחראי באופן בלעדי לגבות, על חשבונך, את התוכן אותו אתה מעלה.
              החברה לא תישא בכל אחריות לנזקים אשר
              עשויים להיגרם לך כתוצאה מאובדן תוכן.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              לחברה מסור שיקול הדעת הבלעדי להחליט איזה תוכן צדדים שלישיים יוצג,
              משך הזמן בו יוצג, מה יהיה מיקומו
              ועיצובו וכל עניין אחר הקשור בפרסומו במסגרת והיא איננה מתחייבת
              שתוכן צדדים שלישיים מסוים יתפרסם בכלל,
              או למשך תקופה מסוימת כלשהי.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              תוכן צדדים שלישיים הנמסר לפרסום על ידי המשתמשים ו/או הנשלף ע"י
              המשתמשים אינו מבטא את דעת החברה או
              עמדתה ואין בפרסומו כל ערובה לתקפותו, אמינותו, דיוקו או חוקיותו.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              הנך מסכים כי הנך האחראי הבלעדי לתוכן צדדים שלישיים שהנך מעלה לאתר
              ו/או מקבל גישה מהאתר ולהשלכות
              העלאתו
              ו/או גישתך אליהם. החברה לא תישא בכל אחריות לשימוש של צדדים שלישיים
              (לרבות משתמשים) בתוכן צדדים
              שלישיים
              אותו תעלה לאתר ו/או תשלוף באמצעות שימוש באתר.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              אחריות המשתמש להשיג את כל ההסכמות הנדרשות תחת כל דין חל לגבי מידע
              אישי של צדדים שלישיים אשר נכלל
              בתוכן
              אותו המשתמש מעוניין לשתף עם החברה ו/או במסגרת השירותים, ולעמוד בכל
              דרישות הדין החלות בקשר לתוכן
              כאמור.
              החברה אינה אחראית לכל שימוש כאמור ולא תישא באחריות כלשהי בהקשר זה.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              במידה והנך סבור כי תוכן צדדים שלישיים הנו פוגעני, מטעה, אינו
              מדויק, בלתי חוקי או אינו עומד בהוראות
              תנאים אלה, אנא פעל בהתאם להוראות המופיעות תחת הכותרת "נוהל הודעה
              והסרה" להלן.
            </div>
          )}
        />
        <div
          className={`${styles.fontWeightBold} ${styles.textDecorationUnderline} ${styles.marginBottom}`}>
          זכויות בתוכן צדדים שלישיים
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              כשאתה מעביר לחברה ו/או מעלה לאתר תוכן צדדים שלישיים אשר יוצג
              באמצעות השימוש באתר, אתה מצהיר ומאשר
              שאתה
              בעל כל זכויות הקניין הרוחני בהם או כי קיבלת (ותמשיך להחזיק) בכל
              הרישיונות, הזכויות, וההסכמות הדרושות
              מבעלי התוכן המועלה על ידך. כמו כן, הנך מצהיר כי תוכן זה אינו מפר
              כל זכויות של צד שלישי כלשהו, לרבות
              אך
              לא רק זכויות קניין רוחני והזכות לפרטיות. אתה מוותר בזאת באופן
              מפורש על הזכות המוסרית שעשויה להיות לך
              בתוכן צדדים שלישיים.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              החברה אינה מקבלת בעלות בזכויות הקניין הרוחני בתוכן שהמשתמשים מעלים
              לאתר. עם זאת, אתה מעניק לחברה
              רישיון חינם, כלל-עולמי, לא בלעדי, בלתי ניתן לביטול וניתן להעברה
              להשתמש, להעתיק, להפיץ, להכין יצירות
              נגזרות, ולבצע ברבים כל תוכן צדדים שלישיים.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              החברה אינה מתחייבת, איפוא, שמידע שמצאת או פרסמת באתר במועד מסוים
              ימשיך להתפרסם גם בהמשך. כשאתה מעביר
              לחברה תוכן צדדים שלישיים אשר יוצג באתר אתה מסכים ומאשר שהחברה
              יכולה לעשות כל שימוש סביר במידע האישי
              והמזהה הכלול בתוכן צדדים שלישיים במסגרת פעילותה של החברה ועל מנת
              לקדם את מטרותיה.
            </div>
          )}
        />
        <div
          className={`${styles.fontWeightBold} ${styles.textDecorationUnderline} ${styles.marginBottom}`}>
          נוהל הודעה והסרה
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              הנך רשאי לפנות לחברה בדואר אלקטרוני ולבקש מחיקת כל חומר שמסרת
              לפרסום. החברה תשתדל למלא אחר בקשתך,
              אולם
              היא אינה מתחייבת להיענות בכלל, או בתוך פרק זמן מסוים. ידוע לך כי
              קיימות נסיבות שימנעו מחיקת חומר לפי
              בקשתך.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              במידה ומוצגים באתר תכנים ו/או יצירות שבבעלותך ולדעתך מפרים זכויות
              קניין רוחני שלך, לרבות זכויות
              יוצרים
              שלך ו/או פוגעים בפרטיותך ו/או הינם פוגעניים ו/או בלתי הולמים ו/או
              מהווים דיבה ו/או מכילים
              פורנוגרפיה,
              הנך מוזמן ליצור קשר עם החברה בבקשה להסירם (לכתובת הדואר הבאה <span
              className={styles.fontStyleItalic}>contact@accuraiser.com</span
            > תוך הפנייה מדויקת לתוכן המפר, פירוט
              טענותייך וצירוף אסמכתא להיותו כזה וכן פרטי התקשרות, לרבות דואר
              אלקטרוני, שם ופרטים מזהים. היה והתוכן
              ימצא מפר הוא יוסר בהקדם האפשרי ותשלח אלייך הודעה בדואר אלקטרוני
              בעניין. כפי שצוין לעיל, מאחר והחברה
              אינה מתחייבת לנטר את התכנים המועלים לאתר על ידי המשתמשים, אזי
              החברה לא תוכל לדעת כי מפורסם בהם תוכן
              מפר מבלי שתיצור עמנו קשר. החברה לא תהיה אחראית לתוכן מפר כאמור
              בסעיף זה.
            </div>
          )}
        />
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>6. <span
          className={styles.textDecorationUnderline}>	קניין רוחני, סימני מסחר ובעלות בזכויות</span>
        </div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          האתר הינו בבעלות החברה ו/או נמסר לה ברישיון ומוגן על ידי חוקי זכויות
          יוצרים וחוקי קניין רוחני אחרים,
          והחברה מעניקה לך בזאת רישיון מוגבל לעשות שימוש בשירותים, בכפוף לתנאי
          שימוש אלו. כל זכות שלא הוקנתה לך
          במפורש על פי הסכם זה תישמר בידי החברה ונותני הרישיון שלה. שים לב כי
          ככל שתמסור לנו משוב אודות האתר, משוב
          זה יהיה בבעלות החברה, והנך ממחה בזאת לחברה את כל הזכויות שיש לך במשוב
          זה.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              זכויות קניין רוחני
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                האתר והתכנים בו (למעט תוכן צדדים שלישיים), כמו גם הנכסים
                הקנייניים של החברה וכל זכויות הקניין
                הרוחני
                הנוגעות בהם, לרבות אך לא רק, פטנטים ובקשות לפטנטים, סימני מסחר
                ובקשות לסימני מסחר, שמות מסחר,
                מוניטין, זכויות יוצרים, סודות מסחר, שמות מתחם, בין אם רשומים או
                ניתנים לרישום ובין אם לאו (להלן,
                ביחד: "<span className={styles.fontWeightBold}>הקניין
                    הרוחני</span>"), הם בבעלות החברה ו/או נמסרו לה ברישיון
                ומוגנים על ידי חוקי זכויות יוצרים וחוקי קניין
                רוחני אחרים ועל ידי אמנות והסכמים בינלאומיים. כל זכות שלא הוקנתה
                לך במפורש על פי הסכם זה תישמר
                בידי
                החברה ונותני הרישיון שלה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                בכפוף לתנאי שימוש אלו, החברה מעניקה למשתמש, והמשתמש מקבל בזאת,
                רישיון מוגבל, אישי, בלתי-ייחודי,
                ואשר
                ניתן לביטול באופן מלא, בלתי-עביר ושאינו ניתן להמחאה ואשר לא ניתן
                להעניק בו רישיונות-משנה להשתמש
                באתר, בתכנים ובשירותים, כל זאת בהתאם לתנאים ולהוראות בהסכם זה.
                למען הסר ספק, התנאים אינם מקנים
                למשתמש זכות בקניין הרוחני של החברה, אלא אך ורק זכות שימוש מוגבלת
                וזו ניתנת לביטול כאמור. אף הוראה
                בתנאים לא מהווה ויתור על קניינה הרוחני של החברה על פי כל דין.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                הסימנים, הלוגואים של החברה ושאר המזהים הקניינים המשמשים את החברה
                בקשר עם השירות (להלן: "<span
                className={styles.fontWeightBold}>סימני
                    המסחר של החברה</span>") הם כולם סימני מסחר ו/או שמות מסחר של
                החברה, בין אם רשומים ובין אם לאו, בין
                אם ניתנים לרישום ובין אם לאו. כל שאר סימני המסחר, שמות המסחר,
                סימנים מזהים אחרים וסמלים מסחריים
                אחרים (לרבות לוגו כזה או אחר) העשויים להופיע באתר שייכים לבעליהם
                ("<span
                className={styles.fontWeightBold}>סימני
                    מסחר של צדדים שלישיים</span>"). סימני מסחר של צדדים שלישיים
                מובאים במסגרת השירותים (אם בכלל) למטרות
                הצגה, תיאור וזיהוי בלבד. לא ניתנת בזאת כל זכות, רישיון או קניין
                בסימני המסחר של החברה או בסימני
                המסחר של צדדים שלישיים, ולכן עליך להימנע משימוש כלשהו בסימנים
                אלו, אלא אם כן הותר אחרת בתנאי שימוש
                אלה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                המשתמש מסכים בזאת כי יתכן שהחברה תשמור עותקים של מידע מסוים
                הנמסר על ידי המשתמש לצרכי גיבוי או
                לצורך
                אכיפת התנאים, לרבות ביצוע בדיקות של הפרת התנאים לפי שיקול דעתה
                של החברה.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              פידבק (משוב)
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                היה ותספק לנו משוב, פידבק, הערה או הצעה כלשהי לגבי האתר ו/או
                השירותים (להלן: "<span
                className={styles.fontWeightBold}>פידבק</span
              >"), החברה תהיה הבעלים של הפידבק, והנך ממחה בזאת לחברה
                את כל זכויותיך בפידבק מבלי להעניק לך כל תמורה. היה ועל פי דין
                הפידבק אינו יכול להיות מומחה לחברה
                כאמור לעיל, המשתמש מעניק בזאת לחברה רישיון בלעדי, ללא תמלוגים,
                תמידי, כלל עולמי, בלתי הדיר ואשר
                ניתן
                להעניק בו רישיונות-משנה, לשלב את הפידבק בכל המוצרים השירותים
                הנוכחיים או העתידיים של החברה, וכן
                תהיה
                החברה זכאית להשתמש, ללא קבלת אישור המשתמש, בפידבק לכל מטרה שהיא
                וכל זאת מבלי להעניק למשתמש כל
                תמורה.
                כמו כן, אתה מצהיר כי הפידבק אינו כפוף לתנאי רישיון אשר יש בהם
                כדי לחייב את החברה לעמוד בחובות
                נוספים
                בקשר למוצריה ו/או לשירותיה המשלבים את הפידבק.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>7. <span
          className={styles.textDecorationUnderline}>שימושים אסורים</span></div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          ישנן פעולות מסוימות אשר אסורות בעת השימוש בשירותים. אנא קרא הגבלות אלו
          בעיון. אי עמידה בהגבלות ואיסורים
          אלו עשויה להביא לידי סיום את השימוש שלך בשירותים, לפי שיקול דעתנו
          הבלעדי, ואף לחשוף אותך לחבות אזרחית
          ו/או
          פלילית.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              אינך רשאי (ואינך רשאי להתיר לכל צד שלישי), אלא אם הדבר הותר במפורש
              על פי תנאי שימוש אלה: (א) להשתמש
              באתר ו/או בשירותים ו/או בתכנים ו/או בתוכן צדדים שלישיים לכל מטרה
              בלתי חוקית, בלתי מוסרית,
              בלתי-מורשית
              ו/או אסורה; (ב) להשתמש בשירותים ו/או באתר ו/או בתוכן צדדים שלישיים
              ו/או בתכנים למטרות מסחריות או
              שאינן
              פרטיות; (ג) להסיר או להפריד מהאתר ו/או מהשירותים ו/או מהתכנים ו/או
              מתוכן שמועלה ע"י משתמשים כל
              הגבלות
              וסימנים המציינים זכויות קנייניות של החברה או נותני הרישיון שלה,
              לרבות כל ההודעות הקנייניות המופיעות
              בהם (כגון ©, TM או ®); (ד) להפר ו/או לפגוע בזכויות המשתמשים
              לפרטיות וזכויות אחרות, או לאסוף מידע
              אישי
              מזהה אודות משתמשים ללא הסכמתם המפורשת, בין אם באופן ידני או
              באמצעות שימוש בכל רובוט, עכביש, כל יישום
              חיפוש או אחזור, או שימוש באמצעי, בתהליך או בשיטה ידניים או
              אוטומטיים אחרים על מנת להיכנס לאתר
              ולאחזר,
              לאסוף ו/או לשאוב מידע; (ה) לפגוע או לשבש פעולת האתר, השרתים או
              הרשתות המאחסנות את האתר, או להפר כל
              חוק, תקנה, דרישה, נוהל או מדיניות של שרתים או רשתות כאמור; (ו)
              להצהיר הצהרות שקריות או להציג מצג
              שווא
              בנוגע לקשר שלך עם כל אדם או גוף, או לציין במפורש או במרומז כי
              החברה משויכת אליך בכל דרך שהיא, מעניקה
              חסות, תומכת בך, באתר שלך, בעסקך או בהצהרותיך, או להציג מידע שקרי
              או לא מדויק אודות השירותים או
              החברה;
              (ז) לבצע כל פעולה היוצרת או העלולה ליצור עומס גדול ובלתי סביר על
              תשתית האתר; (ח) לעקוף את האמצעים
              בהם
              החברה משתמשת על מנת למנוע או להגביל את הגישה לאתר; (ט) להעתיק,
              לתקן, לשנות, להתאים, למסור, להנגיש,
              לתרגם, להפנות, לבצע הנדסה חוזרת, להמיר קוד בינארי לקוד פתוח, לעשות
              דה-קומפילציה, או להפריד כל חלק
              באתר, בתכנים או בשירותים או להציג לציבור, ליצור יצירות נגזרות,
              לבצע, להפיץ או לעשות שימוש דומה
              בתכנים;
              (י) להעתיק, להפיץ, להציג, לעבד, לתת רישיון משנה, לעשות כל שימוש
              מסחרי, למכור, להשכיר, להעביר,
              להלוות,
              לאסוף, לתרגם, ליצור יצירה נגזרת, לערוך הנדסה הופכית, לשלב עם תוכנה
              אחרת - כל חומר הכפוף לזכויות
              קנייניות של החברה, לרבות הקניין הרוחני (כהגדרתו של מונח זה לעיל)
              של החברה, בכל אופן או בכל אמצעי;
              (יא)
              לעשות כל שימוש בתכנים בכל אתר אחר או רשת מחשבים, לכל מטרה, ללא
              הסכמה של החברה בכתב ומראש; (יב) ליצור
              סביבת דפדפן, לתחם (frame), ליצור העתק (mirror) או לבצע in-line
              linking לכל חלק מהאתר והתכנים; (יג)
              למכור, לתת רישיון, או לנצל למטרה מסחרית כלשהי כל שימוש או גישה
              לשירותים; (יד) ליצור מאגר מידע על-ידי
              הורדה ואחסון שיטתיים של כל או חלק מהתכנים; (טו) להעביר או להנגיש
              בכל דרך אחרת, בקשר לתוכן צדדים
              שלישיים, לתכנים, לאתר או לשירותים, כל וירוס, "תולעת", סוס טרויאני,
              באג, רוגלה, נוזקה, או כל קוד
              מחשב,
              קובץ או תוכנה אחרים אשר עשויים להזיק, או נועדו להזיק לפעילות של כל
              חומרה, תוכנה, ציוד תקשורת, קוד או
              רכיב; ו/או (טז) להשתמש בתוכן צדדים שלישיים ו/או בתכנים ו/או באתר
              ו/או בשירותים לכל מטרה בלתי מורשית
              או
              שאינה הולמת את מטרת השימוש בשירותים ו/או להפר אי אלו מהתנאים.
            </div>
          )}
        />
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>8. <span
          className={styles.textDecorationUnderline}>מדיניות פרטיות</span></div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          תנאי מקדמי לשימושך בשירותים שלנו הינו קריאה והסכמה למדיניות הפרטיות
          שלנו.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              אנו מכבדים את הפרטיות שלך ומחויבים להגן על המידע האישי שאתה משתף
              עמנו. אנו מאמינים כי יש לך את הזכות
              להכיר את המדיניות שלנו בנוגע לאיסוף ושימוש במידע המתקבל על ידינו
              בזמן השימוש שלך בשירותים. מדיניות
              איסוף המידע לסוגיו מתוארת במדיניות הפרטיות שלנו, המהווה חלק בלתי
              נפרד מתנאי שימוש אלה. אתה מסכים
              ומאשר
              כי החברה תעשה שימוש במידע אישי שלך בהתאם למדיניות הפרטיות. אם
              בכוונתך להיכנס ו/או להתחבר ו/או להשתמש
              באתר, עליך לקרוא תחילה ולהסכים למדיניות הפרטיות.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              תנאי מקדמי לשימושך בשירותים הנו קריאה והסכמה למדיניות הפרטיות.
              הואיל ומדיניות הפרטיות יכולה להשתנות
              מדי פעם, מומלץ שתחזור ותתעדכן בה מעת לעת.
            </div>
          )}
        />
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>9. <span
          className={styles.textDecorationUnderline}>קישורים לאתר וקישורים לאתרי צדדים שלישיים </span>
        </div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          אנו מברכים קישורים לכל דף באתר, אולם אינך רשאי לקשר לאתר מאתר שאינו
          שלך או שאינך מחזיק באישור לשימוש בו
          ואינך רשאי להצהיר על כל קשר או אישור של החברה לשירותים המוענקים על ידך
          או לתאר את החברה באופן כוזב או
          פוגעני. כמו-כן, נבקש להביא לתשומת ליבך, שהאתר ככלל כולל קישורים אשר
          מאפשרים לך לעזוב אותו ולהיכנס לאתרים
          או לשירותים שאינם של החברה ואינם בשליטתה. השימוש באתרים אלו הוא על
          אחריותך בלבד.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              אנו מברכים קישורים לכל דף באתר. הנך רשאי ליצור קישור היפרטקסט לאתר
              כל עוד הקישור אינו מצהיר במפורש
              או
              במשתמע על כל קשר או אישור של פלטפורמת האינטרנט שלך ו/או מוצרים
              ו/או שירותים שאינם ניתנים על ידי
              החברה,
              ואינו מתאר את החברה באופן כוזב או פוגעני. אינך רשאי לקשר לאתר מאתר
              שאינו שלך או שאינך מחזיק באישור
              לשימוש בו. בכל מקרה שבו אתה מקשר לאתר, הנך מצהיר כי האתר שלך אינו
              מכיל תוכן שאינו חוקי, פוגע או מפר
              זכויות של צדדים שלישיים. עם זאת, איננו מתירים מסגור (framing)
              אוin-line linking .
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              קישורים מסוימים המופיעים באתר ו/או מוצגים כחלק מהשירותים, מאפשרים
              לך להיכנס לאתרים או לשירותים שאינם
              של החברה, אינם בשליטת החברה וקישור להם מובא לנוחותך בלבד; החברה
              אינה אחראית לזמינותם, אינה מאשרת
              ואינה
              אחראית לגביהם, לרבות אך לא רק, לכל פרסומות, הטבות, מוצרים או מידע
              אחר המופיע בהם או הזמין באמצעותם
              או
              לכל קישור המצוי בהם. כמו כן, החברה ו/או נציגי החברה המורשים אינם
              אחראיים למדיניות הפרטיות של האתרים
              או
              השירותים של צדדים שלישיים אלה, או לפרקטיקות אחרות הנהוגות על
              ידיהם. כניסתך, שימושך והסתמכותך על
              שירותים אלה והאינטראקציות שלך עם הצדדים השלישיים האמורים הינם
              באחריותך ועל חשבונך בלבד.
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              החברה שומרת את הזכות למחוק כל קישור ובכל עת. החברה לא תהיה אחראית
              לכל נזק אשר נגרם, או לכאורה נגרם,
              בקשר עם או כתוצאה משימושך או הסתמכותך על תכנים, שירותים, מוצרים או
              פרסומות הזמינים באתרים או שירותים
              של צדדים שלישיים אלה. רוב האתרים והשירותים המקושרים מספקים מסמכים
              משפטיים, לרבות תנאי שימוש ומדיניות
              פרטיות, החלים על השימוש בהם. אנו ממליצים לך לקרוא מסמכים אלו בעיון
              לפני השימוש בשירותים אלו, בין
              היתר,
              על מנת להיות מודע לסוג המידע הנאסף לגביך.
            </div>
          )}
        />
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>10. <span
          className={styles.textDecorationUnderline}>זמינות </span></div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          אנו עושים מאמצים על מנת להבטיח שהשירותים שלנו יהיו זמינים עבורך באופן
          רציף. עם זאת, החברה אינה אחראית או
          מתחייבת כי האתר ו/או השירותים יפעלו או יהיו זמינים בכל עת ללא הפרעות
          וללא פגם, למשל עקב הפסקות בחיבור
          האינטרנט שלך והפסקות בפעילות החומרה או התוכנה בשל בעיות טכניות או
          אחרות שאינן בשליטת החברה.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              זמינות ופונקציונאליות השירותים שלנו תלויה בגורמים רבים, לרבות
              תוכנה, חומרה, רשתות תקשורת, ספקי
              שירותים
              וקבלנים של החברה או צדדים שלישיים אחרים (לרבות אלה המספקים שירותי
              אחסון ענן, שירותי רישום לאתרים
              ועוד).
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              אנו עושים מאמצים סבירים על מנת להבטיח שהשירותים יהיו זמינים לך
              באופן רציף. יחד עם זאת, החברה לא תהיה
              אחראית, ואיננה מבטיחה או מתחייבת כי האתר ו/או השירותים יפעלו ו/או
              יהיו זמינים בכל עת ללא הפרעות או
              תקלות, וכי יהיו ללא פגם. אתה מסכים בזאת כי החברה לא תהיה אחראית
              לאי היכולת של השירותים לפעול או
              להיות
              נגישים, מכל סיבה שהיא; לרבות הפסקות בפעילות האינטרנט או רשתות
              תקשורת והפסקות בפעילות החומרה או
              התוכנה
              בשל בעיות טכניות או אחרות שאינן בשליטת החברה (למשל, סיכול, כוח
              עליון, רשלנות של צדדים שלישיים וכד').
            </div>
          )}
        />
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div>
              היה ותידרש תחזוקה לשירותים באופן אשר ישפיע על זמינותם, החברה עשויה
              (אך היא אינה מחויבת) ליידע אותך
              על
              כך מבעוד מועד.
            </div>
          )}
        />
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>11. <span
          className={styles.textDecorationUnderline}>הסרת אחריות והגבלת אחריות  </span>
        </div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          זכות השימוש בשירותים ניתנת לך כמות שהיא (“AS-IS”), ושימושך בהם הינו על
          אחריותך האישית והבלעדית.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              <span
                className={styles.textDecorationUnderline}>הסרת אחריות</span>:
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div className={styles.fontWeightBold}>
                במידה המקסימאלית האפשרית על פי דין, האתר ו/או השירותים ו/או
                התכנים ו/או תוכן המשתמשים ניתנים לך
                "כמות שהם" (“AS-IS”) והחברה, לרבות ספקיה, מנהליה, מחזיקי המניות
                שלה, דירקטורים, קבלני המשנה שלה,
                מפיצים, עובדים, גורמים קשורים, סוכנים, נותני הרישיון שלה ושלוחיה
                (להלן, ביחד: "נציגי החברה
                המורשים"), אינם נושאים בכל אחריות או התחייבות מכל סוג שהוא
                (באופן מפורש או מכללא), לרבות אחריות
                לזכות בעלות או לאי הפרה או אחריות מכללא לאיכות מסחרית או להתאמה
                למטרה מסוימת, וכן אחריות הנובעת
                ממהלך העסקים הרגיל או פעולה מסחרית. <span
                className={styles.fontWeightNormal}>ייתכן
                    כי מוקנות לך זכויות צרכניות נוספות אשר אינן ניתנות לשינוי באמצעות תנאי שימוש אלה</span>.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים, אינם מתחייבים (א) כי האתר ו/או
                התכנים ו/או תוכן המשתמשים הנם או
                יהיו
                בטוחים לשימוש, מדויקים, מלאים, ללא תקלות או הפרעות, או נקיים
                מווירוסים, פגמים, תולעים, רכיבים
                מזיקים
                אחרים או הגבלות תוכנה אחרות, (2) כי הם יתקנו כל שגיאות, תקלות או
                פגמים באתר ו/או התכנים (3) כי
                השימוש, אי יכולת להשתמש או לתפעל, או תוצאות השימוש באתר, לרבות
                תוצאות השימוש באתר ו/או בתכנים
                יעמדו
                בדרישות המשתמש או ציפיותיו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים אינם נושאים באחריות וכל ערבון או
                התניה בנוגע לשימוש באתר, לרבות אך
                ללא הגבלה, לגבי זמינות, אמינות או איכות השירות, אינם אחראים ולא
                יישאו באחריות לטעויות, תקלות או
                ליקויים ביחס לתכנים ו/או כל מידע המוצג באתר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים לא יהיו אחראיים בקשר עם חוות דעת
                השמאי המוצעות ו/או לכל תוצאות
                העשויות לנבוע משימוש בשירותים, בתוכן צדדים שלישיים ובתכנים,
                לרבות אחריות בנוגע לתפקוד השירותים,
                למהירות ואמינות השירותים ו/או לתוצאות השימוש בהם ו/או להתקשרות
                בין המשתמש לבין לקוחותיו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים לא יהיו אחראיים לכל תוצאה הנובעת
                מתקלות טכניות (לרבות אך לא רק בקשר
                לקישוריות האינטרנט, עומס קו או שרתים, עיכובים והפרעות קשורים)
                והנובעות מספקי אינטרנט
                וטלקומוניקציה.
                הנך מסכים כי השימוש באתר, בשירותים ו/או בתכנים הנם באחריותך
                הבלעדית.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים לא יהיה אחראיים לנזק כלשהו, לרבות
                אך לא רק, נזק הנובע משימושך בחוות
                דעת השמאי המוצעות ו/או בשירותים, בתכנים ו/או בהסתמכות עליהם.
                לחברה ו/או לנציגי החברה המורשים לא
                תהיה
                כל אחריות ביחס לטעיות ו/או אי דיוקים שנפלו בכל מידע המופיע באתר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                המשתמש יהיה אחראי לכל החלטה שיקבל בקשר עם שימוש באתר ו/או בחוות
                דעת השמאי המוצעות. מובהר כי ההחלטה
                הסופית של המשתמש בהפקת חוות דעת מקרקעין ללקוחותיו באמצעות האתר
                הינה באחריותו הבלעדית וכי החברה לא
                תשא בשום אחריות בגין חוות דעת מקרקעין שעורך המשתמש.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה מעודדת את המשתמשים לוודא כי הנתונים שמוזנים על ידם ו/או
                מופקים ע"י צדדים שלישיים במסגרת
                השירותים מדויקים. החברה לא לוקחת אחריות בקשר עם מידע שמוזן ע"י
                המשתמשים, אשר מועלה ע"י המשתמשים על
                פי שיקול דעתם הבלעדי. החברה לא תשא באחריות לגבי מידע ו/או נתונים
                של צדדים שלשיים, לרבות בקשר
                לדיוקו
                ו/או שלמותו.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                היה והמשתמש ו/או המעסיק (לפי העניין) בחרו באפשרות של שימוש במאגר
                מידע שיתופי, המשתמש ו/או המעסיק
                יהיו האחראיים הבלעדיים לאיכות, שלמות ודיוק המידע השיתופי וכן לכל
                שימוש שלהם במידע שיתופי של
                משתמשים
                אחרים באתר. החברה ו/או נציגי המורשים לא יהיה אחראיים לנזק כלשהו
                הנובע לבחירת משתמש ו/או מעסיק
                באופצית מאגר המידע השיתופי ו/או בשימוש כלשהו במידע שיתופי על ידו
                ו/או על ידי משתמשים אחרים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                היה וסמכויות שיפוט מסוימות אינן מאפשרות החרגות או הגבלות כאמור
                לעיל, ההחרגות וההגבלות הנזכרות לעיל
                לא תחולנה במלואן, אלא רק במידה המקסימאלית המותרת על פי הדין החל.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              <span
                className={styles.textDecorationUnderline}>הגבלת אחריות</span>:
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                החברה ו/או נציגי החברה המורשים לא ישאו בכל אחריות לכל נזק, לרבות
                נזק ישיר, גוף, תוצאתי, מיוחד,
                עקיף
                ו/או אקראי, שייגרם לך או לצדדים שלישיים עקב השימוש שלך באתר,
                בשירותים ו/או במוצרים, במישרין או
                בעקיפין, ובכלל זה (אך לא רק) אובדן הכנסות, רווחים, מכירות או
                מידע כלשהם, ו/או כל הפסד או נזק עסקי
                ומסחרי אחר הנובע או קשור לשימוש בשירותים על ידך, בכל עילת תביעה
                שהיא (חוזית, נזיקית או אחרת), והכל
                גם במקרה שבו החברה ו/או נציגי החברה המורשים הוזהרו בדבר האפשרות
                כי עלול להיגרם נזק מסוג זה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                אתה מסכים כי החברה אינה מחויבת להיות מעורבת בכל סכסוך שעשוי
                להיות לך עם לקוחותיך, המעסיק ו/או
                משתמשים אחרים באתר,בקשר עם השימוש שלך באתר ו/או בשירותים. הינך
                משחרר בזאת את החברה ו/או את נציגי
                החברה המורשים מכל טענה, תביעה, נזקים שעשויים להיגרם לך הנובעים
                מסכסוך בינך לבין לקוחותיך, המעסיק
                ו/או משתמשים אחרים באתר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrowOutline}
            label={(
              <div>
                מבלי לגרוע מהאמור לעיל, האחריות הכוללת של החברה ו/או נציגי החברה
                המורשים כלפיך לכל נזקיך מכל סוג
                שהוא, לא תעלה על הסכום אותו שילמת (ככל שרלוונטי) לחברה בשנה בה
                אירע האירוע המקים לך טענה כלפי
                החברה,
                או לחלופין סכום של מאה (100) שקלים חדשים, לפי הגבוה מביניהם.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>12.
          <span className={styles.textDecorationUnderline}> שיפוי</span>
        </div>
        <div className={styles.marginBottom}>
          המשתמש מסכים להגן ולשפות את החברה ואת נציגי החברה המורשים מפני ונגד כל
          תביעה, נזק, הפסד, התחייבות,
          אחריות,
          הוצאה וחוב (לרבות אך לא רק, שכר טרחת עורך דין) אשר נובעים מ: (א)
          שימושו באתר ו/או בשירותים ו/או בתכנים
          שלא
          בהתאם לתנאי שימוש אלה; (ב) כל הפרה מצדו של תנאי שימוש אלה; (ג) הפרה
          מצדו של כל זכות של צד שלישי, לרבות
          אך
          לא רק, זכויות קניין רוחני או הזכות לפרטיות; ו-(ד) כל נזק מכל סוג שהוא,
          בין אם נזק ישיר, עקיף, מיוחד או
          תוצאתי, שגרם לצד שלישי אשר קשור לשימושו באתר או בתכנים. מובהר בזאת כי
          חובת השיפוי האמורה תחול אף לאחר
          סיום
          התקשרותך עם החברה.
        </div>
        <div className={styles.marginBottom}>
          מבלי לגרוע מכלליות האמור לעיל, אנו שומרים את הזכות הבלעדית לנהל את
          ההגנה והשליטה הבלעדית בכל עניין והליך
          הקשור בשיפוי מצדך, באופן שאינו גורע מחובת המשתמש כאמור, והמחייב אותו
          לשתף פעולה מלאה איתנו בניהול הליך
          כאמור. המשתמש מאשר כי לא יסכים לפשרה בכל עניין הכפוף לשיפוי על ידו
          מבלי לקבל לכתחילה את הסכמתנו בכתב
          לכך.
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>13. <span
          className={styles.textDecorationUnderline}>שינויים ועדכונים של השירותים ותנאי שימוש אלו  </span>
        </div>
        <div className={`${styles.fontWeightBold} ${styles.marginBottom}`}>
          מעת לעת, החברה רשאית לעדכן ולשנות את השירותים, וכן לחסום או לבטל את
          חשבונך או להפסיק את מתן השירותים,
          לפי
          שיקול דעתה. כמו כן, החברה רשאית לשנות את תנאי שימוש אלו מעת לעת
          ובמקרים מסוימים, תוך יידוע שלך אודות
          שינויים מהותיים.
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              שינויים בשירותים
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה רשאית, מעת לעת, לעדכן, לשדרג, לשפר ולאבטח את האתר, למחוק
                כל מידע או תוכן או לשנות, לתקן,
                לשפר,
                ולעשות שינויים אחרים או להפסיק הספקת או מתן מידע, תכנים או
                תכונות בהם מבלי לתת כל הודעה מוקדמת
                ולפי
                שיקול דעתה הבלעדי.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              חסימת וביטול השירות
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה רשאית, בכל עת, לחסום ו/או להגביל באופן קבוע את גישתך
                לשירותים ו/או לחסום, לבטל ו/או להגביל
                גישה לחשבון על פי שיקול דעתה הבלעדי (בנוסף לכל סעד אחר העשוי
                לעמוד לרשות החברה על פי כל דין).
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                נציין כי אנו עשויים להשעות את הגישה לשירותים אם אנחנו סבורים,
                לפי שיקול דעתנו הבלעדי, כי אחד (או
                יותר) מן האירועים הבאים התרחשו: (א) יש סיכון לביטחון או פרטיות;
                (ב) קיים איום על הביטחון או השלמות
                של הרשת שלנו או השרתים שלנו; (ג) השעיה נדרשה כדי להגן על זכויות,
                רכוש או בטיחות של החברה, משתמשיה
                או
                הציבור; (ד) הפרת תנאים אלה; (ה) אם, לפי שיקול דעתנו הבלעדי, נקבע
                כי הנך מתנהל כעבריין מועד (משתמש
                אשר קיבל הודעה בעניין פעילות מפרה יותר מפעמיים); (ז) אם פעילותך
                עלולה להזיק לחברה ו/או למשתמשיה או
                אינה הולמת; ו/או (ח) אנו נדרשים לכך על פי דין.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                בנוסף, החברה רשאית בכל עת, על פי שיקול דעתה הבלעדי, להפסיק את
                השירותים, באופן זמני או לצמיתות,
                מבלי
                לתת כל הודעה מוקדמת. הנך מסכים ומאשר כי החברה לא תהיה אחראית
                לאובדן מידע ו/או נזקים כלשהם הנובעים
                או
                הקשורים בהחלטתה להפסיק או להשהות את פעילות השירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                הנך מסכים ומאשר כי החברה אינה נושאת בכל אחריות ביחס או בקשר עם
                הפסקת פעילות השירותים ו/או אובדן
                נתונים כלשהם.
              </div>
            )}
          />
        </div>
        <PolicyListItem
          icon={arrowOutline}
          label={(
            <div className={styles.fontWeightBold}>
              שינוי וביטול תנאי השימוש
            </div>
          )}
        />
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                תנאים אלה יעמדו בתוקפם עד לסיומם כמפורט במסמך זה. אי ציות לתנאים
                יסיים את השימוש שלך בשירותים ואת
                תנאים אלו. במקרה של אי-יכולתך לעמוד בתנאים, החברה יכולה מיידית,
                באופן זמני או קבוע להגביל, להשעות
                או
                לסגור את חשבונך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אם אתה מתנגד לכל תנאי בתנאי שימוש אלו, כפי שיתוקנו מעת לעת, או
                אינך מרוצה מהשירות, אתה רשאי לסיים
                את
                ההתקשרות עמנו בכל עת באמצעות שליחת הודעת דואר אלקטרוני
                לכתובת <span
                className={styles.fontStyleItalic}>contact@accuraiser.com</span
              > וזה יהיה הסעד היחיד שיעמוד לרשותך
                בנסיבות אלו. בנסיבות אלו או בסיום ההתקשרות לפי התנאים בעקבות
                כישלון לעמוד בתנאים, כל הזכויות
                המוקנות
                לך לעיל יסתיימו באופן אוטומטי ותחויב להפסיק לאלתר כל שימוש
                בשירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה רשאית, על פי שיקול דעתה הבלעדי, לשנות את התנאים מעת לעת,
                ומבקשת ממך לשוב ולבקר בדף זה לעיתים
                קרובות ככל האפשר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                החברה תעשה מאמצים סבירים להודיע לך על כל שינוי מהותי בתנאים,
                באמצעות הודעה באתר ו/או על ידי משלוח
                הודעת דואר אלקטרוני לכתובת הדואר האלקטרוני אותה העברת לחברה
                במסגרת השימוש בשירותים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                שינויים מהותיים שיבוצעו על ידי החברה בתנאים ייכנסו לתוקף תוך
                שבעה (7) ימים ממועד ההודעה כאמור. כל
                שאר השינויים בתנאים ייכנסו לתוקף בתאריך העדכון האחרון של התנאים,
                והמשך השימוש שלך בשירותים לאחר
                תאריך העדכון האחרון הנקוב יהווה הסכמה שלך לכך שהשינויים יחייבו
                אותך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                במידה ונצטרך לשנות את התנאים על מנת לעמוד בדרישות הדין, שינויים
                אלה יכנסו לתוקף באופן מידי או
                כנדרש
                על פי דין, וזאת ללא מתן הודעה מוקדמת.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                הוראות תנאי שימוש אלה, אשר על פי טבען שורדות את סיום ההתקשרות
                בכדי לקיים את מטרות התנאים יישארו
                בתוקף. מבלי לגרוע מכלליות האמור לעיל, הסעיפים בדבר קניין רוחני,
                הסרת אחריות, הגבלת אחריות, שיפוי
                וסעיף "כללי" ימשיכו לחול אף לאחר סיום ההתקשרות.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>14. <span
          className={styles.textDecorationUnderline}>	תנאים משפטיים כללים</span>
        </div>
        <div className={styles.fontWeightBold}>
          תנאים אלה מהווים את ההסכם הכולל בינך ובין החברה. על מנת להסדיר את כלל
          החובות והזכויות המשפטיות בינינו
          ובין
          המשתמשים שלנו, לרבות בעניין יישוב סכסוכים אשר עשויים להתגלע בינך ובין
          החברה, תנאי שימוש אלו כוללים תנאים
          משפטיים נוספים.
        </div>
        <div className={styles.innerPaddingTen}>
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                תנאי שימוש אלה ממצים את מלוא ההבנות והתנאים שהוסכמו בינך לבין
                החברה בקשר לנושאים המופיעים בתנאים
                אלה, והם גוברים על כל הסכמות אחרות, קודמות או תקפות, בכתב או בעל
                פה, בינך לבין החברה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תביעה בקשר לשימוש בשירותים, תהיה כפופה לחוקי מדינת ישראל,
                ותתפרש על-פי חוקים אלה (מבלי ליתן
                תוקף
                לכללי ברירת הדין הבינלאומי הקבועים בהם), ואף לא יחולו עליה אמנת
                האומות המאוחדות בנוגע לדין האחיד
                בדבר מכר טובין בינלאומי.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל מחלוקת אשר תנבע או תהיה קשורה לשימוש שלך באתר תובא לדיון בבתי
                המשפט המוסמכים במחוז תל אביב,
                ישראל, ואתה מסכים בזאת לסמכות השיפוט הייחודית והמקומית של בתי
                משפט אלה. הנך מסכים לוותר על כל
                ההגנות
                בדבר היעדר סמכות שיפוט פרסונלית ופורום לא נאות, ומסכים כי כתבי
                בי-דין יומצאו באופן המותר על פי
                הדין
                החל ו/או על פי החלטת בית משפט. על אף האמור לעיל, החברה רשאית
                לבקש מתן צווי מניעה בכל בית משפט
                מוסמך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                תנאי שימוש אלה אינם יוצרים ולא יתפרשו כאילו הם יוצרים יחסי
                שותפות, מיזם משותף, יחסי עובד-מעסיק,
                יחסי
                שליחות או יחסי נותן-מקבל זיכיון בין הצדדים.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                שום ויתור של מי מהצדדים על כל הפרה או מחדל על פי הסכם תנאים אלה
                זה לא ייחשב כויתור על כל הפרה או
                מחדל, בין אם קודמים או מאוחרים יותר.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל כותרת של סעיף או כל כותרת אחרת בתנאים אלה מובאת לצורכי נוחות
                בלבד, ואיננה מגדירה או מבארת כל
                סעיף
                או הוראה הכלולים בתנאים אלה
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div className={styles.fontWeightBold}>
                הנך מאשר ומסכים כי כל עילת תביעה שעשויה להיות לך, הנובעת
                מהשירותים או הנוגעת להם, תעמוד לך במשך
                שנה
                אחת (1) מיום קרות האירוע. לאחר תקופה זו, מוסכם בזאת בין הצדדים
                כי עילת תביעה זו תתיישן.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                היה וייקבע על ידי גוף מוסמך כי הוראה כלשהי מתנאי שימוש אלה אינה
                חוקית, בטלה או שמכל סיבה שהיא אין
                אפשרות לאוכפה, אזי יראו הוראה זו כהוראה שניתן להגבילה או להפרידה
                מתנאים אלה, וההוראה האמורה (במידה
                המקסימאלית האפשרית על פי דין) לא תשפיע על התוקף והאפשרות לאכוף
                הוראה כלשהי מבין ההוראות הנותרות של
                תנאים אלה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אינך רשאי להמחות, להעניק רישיון-משנה או להעביר באופן אחר את
                זכויותיך או את התחייבויותיך, כולן או
                מקצתן, על פי תנאים אלה לצד ג' כלשהו ללא הסכמתנו מראש ובכתב. הננו
                רשאים להמחות או להעביר את
                התחייבויותינו על פי תנאים אלה ללא הגבלה וללא הודעה על כך.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                כל תיקון לתנאי שימוש אלה לא יהיה בעל תוקף משפטי מחייב אלא אם כן
                נעשה בכתב על ידי החברה.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                הצדדים מסכימים כי כל התכתבות הקשורה בתנאים אלה תהיה בכתב (בדואר
                אלקטרוני או בדואר רגיל), בשפה
                העברית או האנגלית.
              </div>
            )}
          />
          <PolicyListItem
            icon={arrow}
            label={(
              <div>
                אתה מסכים, מבלי להגביל, כי גרסה מודפסת של תנאים אלה ושל כל הודעה
                אשר ניתנה באופן אלקטרוני תהיה
                ראיה קבילה בהליכים שיפוטיים או מנהליים אשר יתבססו על תנאים אלה,
                או בקשר אליהם, באותה מידה ובכפוף
                לאותם תנאים כמו מסמכים ורשומות עסקיים אחרים אשר הופקו במקור
                ונשמרו בגרסה מודפסת.
              </div>
            )}
          />
        </div>
        <div className={`${styles.unitHeader} ${styles.marginBottom}`}>15. <span
          className={styles.textDecorationUnderline}>	שאלות</span></div>
        <div className={styles.fontWeightBold}>
          במידה ויש לך שאלות נוספות או הערות בנוגע לתנאים, הינך מוזמן לפנות
          אלינו באמצעות דואר אלקטרוני
          בכתובת: <span
          className={`${styles.fontStyleItalic} ${styles.fontWeightNormal}`}>contact@accuraiser.com</span> ואנו
          נעשה את מירב המאמצים לחזור אליך תוך זמן סביר.
        </div>
      </div>
      {/*Second document end*/}
    </div>
  );
};

export default PrivacyPolicy;
